//setTimeout(function(){
//if (window != undefined && window.navigator.userAgent.toLowerCase().indexOf('msie') == -1 && window.navigator.userAgent.toLowerCase().indexOf('trident') == -1) {
//    if ((window.inTestMode != undefined && window.inTestMode == true) || window.isDeveloperMachine == true) {
//        //console.log is turned on
//    } else {
//        //console.log is turned off
//        var console = {};
//        console.log = function () { };
//    }
//}
//}, 1000);

angular.module('ui.bootstrap', []).controller('carousel', function () {
});

var app = angular.module('app', [
    'ngSanitize',
    'Giant.Analytics',
    'rzModule',
    'ui.bootstrap',
    'uiGmapgoogle-maps',
    'ngCookies',
    'naif.base64'
]);

//Add prototype extensions
app.run(['$timeout', '$document', function ($timeout, $document) {
    angular.element.prototype.scrollToElement = function (options) {
        options = angular.extend({
            marginTop: 0,
            duration: 750
        }, options);

        $document.find('html, body').animate({
            scrollTop: $document.find('html, body').offset().top + options.marginTop
        }, options.duration);
    };
}]);

app.factory('helpers', ['$document', function ($document) {
    var factory = {};
    var _imagesToPartnumbers = [];

    factory.getGeolocation = function (address, callback) {
        getLatLng(address + ' ' + country, function (lat, lng) {
            if (lat != undefined) {
                if (callback) {
                    callback(lat, lng);
                }
            } else {
                //try to find without country suffix
                getLatLng(address, function (lat, lng) {
                    if (callback) {
                        callback(lat, lng);
                    }
                })
            }
        })
    }

    factory.getBrowserLocation = function (callback) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {

                var latlng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                //latlng = new google.maps.LatLng(52.706926, -1.093812);
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({ latLng: latlng }, function (results, status) {
                    var dealercity = '';
                    if (status == google.maps.GeocoderStatus.OK) {
                        if (results[1]) {
                            var arrAddress = results;
                            console.log(results);
                            $.each(arrAddress, function (i, address_component) {
                                if (address_component.types[0] == "locality") {
                                    console.log("dealercity: " + address_component.address_components[0].long_name);
                                    dealercity = address_component.address_components[0].long_name;
                                }
                            });
                            if (dealercity.length == 0) {
                                //try to find by administrative_area_level_4
                                $.each(arrAddress, function (i, address_component) {
                                    if (address_component.types[0] == "administrative_area_level_4") {
                                        console.log("dealercity: " + address_component.address_components[0].long_name);
                                        dealercity = address_component.address_components[0].long_name;
                                    }
                                });
                            }
                            if (dealercity.length == 0) {
                                //try to find by postal_town
                                $.each(arrAddress, function (i, address_component) {
                                    if (address_component.types[0] == "postal_town") {
                                        console.log("dealercity: " + address_component.address_components[0].long_name);
                                        dealercity = address_component.address_components[0].long_name;
                                    }
                                });
                            }
                        } else {
                            dealercity = lblNoLocationFound;
                        }
                    } else {
                        //Raygun.send("Google Maps Geocoder exception. Status: " + status);
                        dealercity = "Geocoder failed due to: " + status;
                    }

                    if (callback && dealercity.length > 0) {
                        callback(position.coords.latitude, position.coords.longitude, dealercity);
                    }
                });
            });
        }
    }

    factory.__envMobile = undefined;
    factory.isMobile = function () {
        if (factory.__envMobile !== undefined)
            return factory.__envMobile;

        var envs = ['xs', 'sm', 'md', 'lg'];

        var el = angular.element('<div>');
        $document.find('body').append(el);

        for (var i = envs.length - 1; i >= 0; i--) {
            var env = envs[i];

            el.addClass('hidden-' + env);
            if (el.is(':hidden')) {
                el.remove();
                factory.__envMobile = env === 'xs';

                return factory.__envMobile;
            }
        }
    };

    factory.setImagesToPartnumbers = function (imagesToPartnumbers) {
        _imagesToPartnumbers = imagesToPartnumbers;
    };

    factory.getImagesToPartnumbers = function () {
        return _imagesToPartnumbers;
    };

    return factory;
}]);

app.service('cartService', ['$http', '$window', '$q', '$cookies', function ($http, $window, $q, $cookies) {
    var factory = {};
    factory._corsActive = '';
    factory._masterDomain = $window.masterDomain;
    factory._cart = {};
    factory._cartSummary = {};

    factory.CorsActive = function () {
        console.log('cors 1a: start');
        var def = $q.defer();
        //GDG / 20180111 / uitgezet omdat het niet werkte op windows 8 met IE10.
        //if (($cookies.get('corsActive') == undefined || $cookies.get('corsActive').length == 0) && (masterDomain == '' || masterDomain.indexOf('www.giant-bicycles.com') > -1)) {
        //    //in dit geval is cors niet nodig, daarom cookie direct zetten
        //    $cookies.put('corsActive', 'true');
        //    console.log('cors 2a: cors not necessary working on domain ' + masterDomain);
        //}
        if ($cookies.get('corsActive') == undefined || $cookies.get('corsActive').length == 0) {
            console.log('cors 2b: corsActive cookie undefined or length = 0');
            $http({
                method: 'GET',
                url: masterDomain + '/' + $window.culture + '/shop/set-cors-cookie?r=' + Math.random(),
                cache: false,
                withCredentials: true
            }).then(function (res) {
                console.log('cors 3: return of shop/set-cors-cookie: ' + res.data);
                $http({
                    method: 'GET',
                    url: masterDomain + '/' + $window.culture + '/shop/get-cors-cookie?r=' + Math.random(),
                    cache: false,
                    withCredentials: true
                }).then(function (res) {
                    console.log('cors 4: return of shop/get-cors-cookie: ' + res.data);
                    factory._corsActive = res.data;
                    //$cookies.CorsActive = res.data;
                    $cookies.put('corsActive', res.data);
                    def.resolve();
                }).catch(function (e) {
                    // handle errors in processing or in error.
                    if (window.isDeveloperMachine == true) {
                        console.log(e);
                        //alert('cors 4 failed: cannot GET cors cookie');
                        //alert(JSON.stringify(e));
                    }
                });
            }).catch(function (e) {
                // handle errors in processing or in error.
                if (window.isDeveloperMachine == true) {
                    console.log(e);
                    //alert('cors 3 failed: cannot SET cors cookie');
                    //alert(JSON.stringify(e));
                }
            });
        } else {
            console.log('cors 2c: corsActive cookie exists: ' + $cookies.get('corsActive'));
            factory._corsActive = ($cookies.get('corsActive') == 'true');
            def.resolve();
        }
        console.log('cors 1b: end');
        return def.promise;
    }

    factory.MasterDomain = function () {
        var def = $q.defer();
        factory.CorsActive().then(function () {
            if ((store != undefined && store.length > 0) || factory._corsActive == true) {
                factory._masterDomain = $window.masterDomain;
            } else {
                factory._masterDomain = ''; //private mode
            }
            def.resolve();
        });
        return def.promise;
    }

    factory.getCartSummary = function () {
        console.log('getCartSummary 1: start');
        var def = $q.defer();
        if ((masterDomain != '' && $window.location.hostname.indexOf('www.giant-bicycles.com') == -1) || (store != undefined && store.length > 0) || $cookies.get('cart-' + $window.cultureFull) != undefined) {
            factory.MasterDomain().then(function () {
                var url = factory._masterDomain + '/' + $window.culture + '/shop/getcart?expanded=false' + '&r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '') + ('&divisionCode=' + $window.divisionCode);
                console.log('getCartSummary 2: url = ' + url);
                $http({
                    method: 'GET',
                    url: url,
                    cache: false,
                    withCredentials: true
                }).then(function (res) {
                    console.log('getCartSummary 3: cart data received');
                    angular.copy(res.data, factory._cartSummary);
                    def.resolve();
                    $('.summary-popup').css("display", "block");
                });
            });
        }
        return def.promise;
    }

    factory.getCart = function (initiator) {
        var def = $q.defer();
        factory.MasterDomain().then(function () {
            var url = factory._masterDomain + '/' + $window.culture + '/shop/getcart?expanded=true&divisionCode=' + $window.divisionCode + '&initiator=' + initiator;

            $http({
                method: 'GET',
                url: url + '&r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : ''),
                cache: false,
                withCredentials: true
            }).then(function (res) {
                angular.copy(res.data, factory._cart);
                def.resolve();
            });
        });
        return def.promise;
    }
    return factory;
}]);

app.service('accountService', ['$http', '$window', '$q', '$cookies', 'cartService', function ($http, $window, $q, $cookies, cartService) {
    var factory = {};
    factory._account = {};
    factory._account.result = {};

    factory.Login = function (email, password, expanded, force) {
        if (expanded == undefined) {
            expanded = false;
        }
        //force needed to login from none masterdomain
        if (force == undefined) {
            force = false;
        }
        var def = $q.defer();
        var token = $cookies.get('accountToken') != undefined ? $cookies.get('accountToken') : '';

        //if (token.length > 0 || (email != undefined && email.length > 0 && password != undefined && password.length > 0)) {
        if (force == false && token.length > 0) {
            //already logged in
            factory._account.result.Token = token;
            def.resolve();
        } else if ((email != undefined && email.length > 0 && password != undefined && password.length > 0) || force == true) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/account/login';

                $http({
                    method: 'POST',
                    url: url,
                    data: { email: email, password: password, token: token, expanded: expanded },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    angular.copy(res.data, factory._account);
                    if (res.data.error != undefined && res.data.error.length == 0) {
                        //if ($cookies.get('accountToken') == null) {
                        var expireDate = new Date();
                        expireDate.setDate(expireDate.getDate() + 7);
                        $cookies.put('accountToken', res.data.result.Token, { path: '/' + culture, 'expires': expireDate });
                        //}
                    } else {
                        if (res.data.result.Token == null) {
                            $cookies.remove('accountToken', { path: '/' + culture });
                        }
                    }

                    def.resolve();
                });
            });
        }
        return def.promise;
    }

    factory.Logout = function () {
        //var def = $q.defer();
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/account/logoutajax';

            $http({
                method: 'GET',
                url: url,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                withCredentials: true
            }).then(function (res) {
                $cookies.remove('accountToken', { path: '/' + culture });
                location.reload();
                //def.resolve();
            });
        });

        //return def.promise;
        //$cookies.remove('accountToken', { path: '/' + culture });
        //location.reload();
    }

    return factory;
}]);

app.controller('Cart', ['$scope', '$http', '$window', '$document', '$timeout', '$sce', '$analytics', 'helpers', 'cartService', function ($scope, $http, $window, $document, $timeout, $sce, $analytics, helpers, cartService) {
    $scope.Cart = {};
    $scope.isCartSummaryOpen = false;
    $scope.culture = $window.culture;

    $scope.getCartSummary = function (fromCache) {
        if (fromCache) {
            $scope.Cart = cartService._cartSummary;
        } else {
            cartService.getCartSummary().then(function () {
                $scope.Cart = cartService._cartSummary;
                //if ($scope.Cart.NumberOfCartItems == 0) {
                //    $cookies.remove('cartActive-' + $window.cultureFull, { path: '/' + $window.culture });
                //}
            })
        }
    }

    $scope.updateCartItem = function (item, quantity) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/updatecartitem' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '')
            $http({
                method: 'POST',
                url: url,
                cache: false,
                withCredentials: true,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                data: { partnumberCode: item.Product.Partnumber.Code, modelId: item.Product.Id, productType: item.Product.ProductTypeId, quantity: quantity, SupplementaryItemPartnumberCode: (item.SupplementaryItemPartnumberCode != null ? item.SupplementaryItemPartnumberCode : '') },
            }).then(function (res) {
                $scope.Cart = res.data;
            });
        });
    }

    $scope.removeCartItem = function (item) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/removecartitem/' + item.Product.Partnumber.Code.toLowerCase() + '/json?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '') + (item.SupplementaryItemPartnumberCode != null ? '&SupplementaryItemPartnumberCode=' + item.SupplementaryItemPartnumberCode : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $scope.Cart = res.data;
            });
        });
    }

    $scope.$on('cartUpdated', function () {
        //$cookies.put('cartActive-' + $window.cultureFull, true);
        $scope.isCartSummaryOpen = false;
        $scope.getCartSummary();
    });

    $scope.parseHtml = function (html) {
        return $sce.trustAsHtml(html);
    };
}]);

app.controller('AccountSummary', ['$scope', '$http', '$window', '$document', '$timeout', '$sce', '$analytics', 'helpers', 'accountService', '$cookies', function ($scope, $http, $window, $document, $timeout, $sce, $analytics, helpers, accountService, $cookies) {
    $scope.Account = '';
    $scope.Login = function () {
        accountService.Login().then(function () {
            if (accountService._account != null && accountService._account.result != null && accountService._account.result.Token != null && accountService._account.result.Token.length > 0) {
                $scope.Account = accountService._account;
            }
        });
    };
    $scope.Logout = function () {
        accountService.Logout();
        //location.reload();
    }

    //$scope.linkToAccount = function () {
    //    accountService.Login(null,null,null,true).then(function () {
    //        window.location = '/' + culture + '/account';
    //    });
    //}
}]);

app.controller('Account', ['$scope', '$http', '$window', '$document', '$timeout', '$sce', '$analytics', 'helpers', 'accountService', '$cookies', function ($scope, $http, $window, $document, $timeout, $sce, $analytics, helpers, accountService, $cookies) {
    $scope.Account = '';
    $scope.isAccountSummaryOpen = false;
    $scope.culture = $window.culture;
    $scope.accountToken = '';
    $scope.loginEmail = '';
    $scope.loginPassword = '';
    $scope.errorLogin = '';
    $scope.proceedLoginButtonClicked = false;

    $scope.Login = function () {
        if ($scope.formLogin.$valid) {
            $scope.proceedLoginButtonClicked = true;
            $scope.errorLogin = '';
            accountService.Login($scope.loginEmail, $scope.loginPassword).then(function () {
                if (accountService._account.result != null && accountService._account.result.Token != null && accountService._account.result.Token.length > 0) {
                    //window.location = window.masterDomain + '/' + culture + '/account';
                    window.location = '/' + culture + '/account';
                } else {
                    //show error
                    $cookies.remove('accountToken', { path: '/' + culture });
                    $scope.errorLogin = accountService._account.error;
                    $scope.proceedLoginButtonClicked = false;
                }
            });
        }
        else {
            if ($scope.formLogin.$error.required != undefined && $scope.formLogin.$error.required.length > 0) {
                $scope.errorLogin = lblMakeSureAllRequiredFieldsAreEntered;
            }
            if ($scope.formLogin.$error.email != undefined && $scope.formLogin.$error.email.length > 0) {
                $scope.errorLogin = lblWrongEmailHasBeenEntered;
            }
        }
    }

    $scope.proceedPasswordForgotten = function () {
        accountService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/account/resetpasswordrequest';
            $http({
                method: 'POST',
                url: url,
                data: { email: $scope.loginEmail }
            }).then(function (res) {
                $scope.messagePasswordForgotten = '';
                $scope.errorPasswordForgotten = '';
                if (res.data.result == true) {
                    $scope.messagePasswordForgotten = res.data.message;
                } else {
                    $scope.errorPasswordForgotten = res.data.message;
                }
            });
        });
    }

    $scope.autoLogin = function () {
        //created for non-giant domains. To check cookie at masterdomain
        accountService.Login(null, null, null, true).then(function () {
            if (accountService._account.result != null && accountService._account.result.Token != null && accountService._account.result.Token.length > 0) {
                window.location = '/' + culture + '/account';
            } else {
                $('.lds-spinner').remove();
                $('#accountLoginContainer').show();
            }
        });
    }

    $scope.parseHtml = function (html) {
        return $sce.trustAsHtml(html);
    };
}]);

app.controller('AccountDetails', ['$scope', '$http', '$window', '$document', '$timeout', '$sce', '$analytics', 'helpers', 'accountService', '$cookies', '$q', 'cartService', function ($scope, $http, $window, $document, $timeout, $sce, $analytics, helpers, accountService, $cookies, $q, cartService) {
    $scope.containsValidAddress = true;
    $scope.Logout = function () {
        accountService.Logout();
    }

    $scope.Submit = function () {
        //e.preventDefault();
        if ($scope.AccountDetails.$valid == false || $scope.Account.Password != $scope.Account.ConfirmPassword) {
            if ($scope.Account.Password != $scope.Account.ConfirmPassword) {
                $scope.errorContactInfo = lblIncorrectPasswords;
            } else {
                $scope.errorContactInfo = lblMakeSureAllRequiredFieldsAreEntered;
            }
            return;
        }
        $('#ContactInfo').submit();
    }

    $scope.CrashReplacement = [];
    $scope.CrashReplacementConfirmed = false;
    $scope.fileResizeLoading = false;
    $scope.uploadFile1 = function () {
        $('#file-1').trigger('click');
        $scope.fileResizeLoading1 = true;
        $scope.$apply();
    }

    $scope.resizeImage1 = function (file, base64_object) {
        //https://github.com/adonespitogo/angular-base64-upload
        //https://github.com/oliver-moran/jimp
        // file is an instance of File constructor.
        // base64_object is an object that contains compiled base64 image data from file.
        var deferred = $q.defer();
        var url = URL.createObjectURL(file);// creates url for file object.
        Jimp.read(url)
            .then(function (item) {
                item
                    .resize(800, Jimp.AUTO)// width of 1280px, auto-adjusted height
                    .quality(50)//drops the image quality to 50%
                    .getBase64(file.type, function (err, newBase64) {
                        if (err) { throw err; }
                        var bytes = Math.round((3 / 4) * newBase64.length);
                        $scope.CrashReplacement.filetype = file.type;
                        $scope.CrashReplacement.filesize = bytes;
                        $scope.CrashReplacement.filename1 = file.name;
                        $scope.CrashReplacement.file1base64 = newBase64;
                        $scope.CrashReplacement.file1Replaced = newBase64.replace('data:image/jpeg;base64,', '');
                        // Note that base64 in this package doesn't contain "data:image/jpeg;base64," part,
                        // while base64 string from Jimp does. It should be taken care of in back-end side.
                        $scope.fileResizeLoading1 = false;
                        $scope.$apply();
                        deferred.resolve($scope.CrashReplacement);
                    });
            })
            .catch(function (err) {
                return console.log(err);// error handling
            });
        return deferred.promise;
    };

    $scope.uploadFile2 = function () {
        $('#file-2').trigger('click');
        $scope.fileResizeLoading2 = true;
        $scope.$apply();
    }
    $scope.resizeImage2 = function (file, base64_object) {
        //https://github.com/adonespitogo/angular-base64-upload
        //https://github.com/oliver-moran/jimp
        // file is an instance of File constructor.
        // base64_object is an object that contains compiled base64 image data from file.
        var deferred = $q.defer();
        var url = URL.createObjectURL(file);// creates url for file object.
        Jimp.read(url)
            .then(function (item) {
                item
                    .resize(800, Jimp.AUTO)// width of 1280px, auto-adjusted height
                    .quality(50)//drops the image quality to 50%
                    .getBase64(file.type, function (err, newBase64) {
                        if (err) { throw err; }
                        var bytes = Math.round((3 / 4) * newBase64.length);
                        $scope.CrashReplacement.filetype = file.type;
                        $scope.CrashReplacement.filesize = bytes;
                        $scope.CrashReplacement.filename2 = file.name;
                        $scope.CrashReplacement.file2base64 = newBase64;
                        $scope.CrashReplacement.file2Replaced = newBase64.replace('data:image/jpeg;base64,', '');
                        // Note that base64 in this package doesn't contain "data:image/jpeg;base64," part,
                        // while base64 string from Jimp does. It should be taken care of in back-end side.
                        $scope.fileResizeLoading2 = false;
                        $scope.$apply();
                        deferred.resolve($scope.CrashReplacement);
                    });
            })
            .catch(function (err) {
                return console.log(err);// error handling
            });
        return deferred.promise;
    };

    $scope.uploadFile3 = function () {
        $('#file-3').trigger('click');
        $scope.fileResizeLoading3 = true;
        $scope.$apply();
    }
    $scope.resizeImage3 = function (file, base64_object) {
        //https://github.com/adonespitogo/angular-base64-upload
        //https://github.com/oliver-moran/jimp
        // file is an instance of File constructor.
        // base64_object is an object that contains compiled base64 image data from file.
        var deferred = $q.defer();
        var url = URL.createObjectURL(file);// creates url for file object.
        Jimp.read(url)
            .then(function (item) {
                item
                    .resize(800, Jimp.AUTO)// width of 1280px, auto-adjusted height
                    .quality(50)//drops the image quality to 50%
                    .getBase64(file.type, function (err, newBase64) {
                        if (err) { throw err; }
                        var bytes = Math.round((3 / 4) * newBase64.length);
                        $scope.CrashReplacement.filetype = file.type;
                        $scope.CrashReplacement.filesize = bytes;
                        $scope.CrashReplacement.filename3 = file.name;
                        $scope.CrashReplacement.file3base64 = newBase64;
                        $scope.CrashReplacement.file3Replaced = newBase64.replace('data:image/jpeg;base64,', '');
                        // Note that base64 in this package doesn't contain "data:image/jpeg;base64," part,
                        // while base64 string from Jimp does. It should be taken care of in back-end side.
                        $scope.fileResizeLoading3 = false;
                        $scope.$apply();
                        deferred.resolve($scope.CrashReplacement);
                    });
            })
            .catch(function (err) {
                return console.log(err);// error handling
            });
        return deferred.promise;
    };

    $scope.uploadFile4 = function () {
        $('#file-4').trigger('click');
        $scope.fileResizeLoading4 = true;
        $scope.$apply();
    }
    $scope.resizeImage4 = function (file, base64_object) {
        //https://github.com/adonespitogo/angular-base64-upload
        //https://github.com/oliver-moran/jimp
        // file is an instance of File constructor.
        // base64_object is an object that contains compiled base64 image data from file.
        $scope.fileResizeLoading4 = true;
        $scope.$apply();
        var deferred = $q.defer();
        var url = URL.createObjectURL(file);// creates url for file object.
        Jimp.read(url)
            .then(function (item) {
                item
                    .resize(800, Jimp.AUTO)// width of 1280px, auto-adjusted height
                    .quality(50)//drops the image quality to 50%
                    .getBase64(file.type, function (err, newBase64) {
                        if (err) { throw err; }
                        var bytes = Math.round((3 / 4) * newBase64.length);
                        $scope.CrashReplacement.filetype = file.type;
                        $scope.CrashReplacement.filesize = bytes;
                        $scope.CrashReplacement.filename4 = file.name;
                        $scope.CrashReplacement.file4base64 = newBase64;
                        $scope.CrashReplacement.file4Replaced = newBase64.replace('data:image/jpeg;base64,', '');
                        // Note that base64 in this package doesn't contain "data:image/jpeg;base64," part,
                        // while base64 string from Jimp does. It should be taken care of in back-end side.
                        $scope.fileResizeLoading4 = false;
                        $scope.$apply();
                        deferred.resolve($scope.CrashReplacement);
                    });
            })
            .catch(function (err) {
                return console.log(err);// error handling
            });
        return deferred.promise;
    };

    $scope.submitCrashReplacement = function () {
        $scope.errorCrashReplacement = null;
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/account/crash-replacement-submit';
            $http({
                method: 'POST',
                url: url,
                data: {
                    SerialNumber: $scope.CrashReplacement.SerialNumber,
                    Description: $scope.CrashReplacement.Description,
                    File1FileName: $scope.CrashReplacement.filename1,
                    File2FileName: $scope.CrashReplacement.filename2,
                    File3FileName: $scope.CrashReplacement.filename3,
                    File4FileName: $scope.CrashReplacement.filename4,
                    File1Base64: $scope.CrashReplacement.file1Replaced,
                    File2Base64: $scope.CrashReplacement.file2Replaced,
                    File3Base64: $scope.CrashReplacement.file3Replaced,
                    File4Base64: $scope.CrashReplacement.file4Replaced,
                    DealerCode: $scope.CrashReplacement.Dealer != null ? $scope.CrashReplacement.Dealer.Code : null
                },
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        if (obj[p] != null) {
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        }
                    return str.join("&");
                },
                withCredentials: true
            }).then(function (res) {
                if (res.data != null && res.data == true) {
                    //saved
                    $scope.CrashReplacementConfirmed = true;
                } else {
                    $scope.errorCrashReplacement = res.data;
                }
                var s = res.data.Result;
            });
        });
    }

    $scope.getBrowserlocationAndGetDealers = function () {
        helpers.getBrowserLocation(function (lat, lng, dealercity) {
            $scope.latitude = lat;
            $scope.longitude = lng;
            $scope.dealercity = dealercity;
            $scope.getDealers();
        });
    }

    $scope.getGeolocationAndGetDealers = function (callback) {
        helpers.getGeolocation($scope.dealercity, function (lat, lng) {
            $scope.latitude = lat;
            $scope.longitude = lng;
            $scope.getDealers();
            if (callback) {
                callback();
            }
        });
    }

    $scope.getDealers = function () {
        $http({
            method: 'POST',
            url: '/' + culture + '/stores/dealers?partnumbercode=' + $scope.CrashReplacement.PartnumberCode,
            data: {
                latitude: $scope.latitude,
                longitude: $scope.longitude,
                keyword: $scope.dealercity
            }
        }).then(function (res) {
            $scope.dealers = res.data.dealers;
        });
    }

    $scope.proceedSelectDealer = function (dealer) {
        $scope.CrashReplacement.Dealer = dealer;
        $('#ModalFindDealer').modal('hide');

        //$scope.errorPointOfPurchase = '';
        //$scope.btnSubmitPointOfPurchase = true;
        //cartService.MasterDomain().then(function () {
        //    var url = cartService._masterDomain + '/' + $window.culture + '/registration/saveContact?source=selectDealer';
        //    $http({
        //        method: 'POST',
        //        url: url,
        //        data: $('#formContactInfo').serialize(),
        //        headers: {
        //            'Content-Type': 'application/x-www-form-urlencoded'
        //        },
        //        withCredentials: true
        //    }).then(function (res) {
        //        if (res.data.Result == true) {
        //            $scope.Registration = res.data;
        //            $scope.isValidPointOfPurchase = true;
        //            $('#collapsePointOfPurchase').collapse('hide');
        //            $('#collapsePurchaseDate').collapse('show');
        //        } else {
        //            $scope.errorPointOfPurchase = res.data.ErrorMessage;
        //        }
        //        $scope.btnSubmitPointOfPurchase = false;
        //    });
        //});
    }

    $scope.validateAddress = function () {
        if (countryId == 16 && $scope.Account.Street.length > 0) {
            $scope.containsValidAddress = /\d/.test($scope.Account.Street);
        }
    }
}]);

app.controller('Shop', ['$scope', '$http', '$window', '$document', '$timeout', '$sce', '$analytics', 'helpers', '$rootScope', 'cartService', 'accountService', function ($scope, $http, $window, $document, $timeout, $sce, $analytics, helpers, $rootScope, cartService, accountService) {
    $scope.dealers = [];
    $scope.localdealers = [];
    $scope.localstockDealers = [];
    $scope.partnumber = '';
    $scope.dealercity = '';
    $scope.productTypeId = $window.productTypeId;
    $scope.productId = $window.productId;
    $scope.latitude = '';
    $scope.longitude = '';
    $scope.localstockonly = false;
    $scope.take = 10;
    $scope.skip = 0;
    $scope.total = 0;
    $scope.localdealersCountFiltered = 0;
    $scope.nowarehousestock = false;
    $scope.containsLocalstock = false;
    $scope.errorContactInfo = '';
    $scope.errorLogin = '';
    $scope.errorPayment = '';
    $scope.errorShippingOption = '';
    $scope.errorDealerSelect = '';
    $scope.contactinfoHTML = '';
    $scope.isValidContactInfo = false;
    $scope.isValidShippingOption = false;
    $scope.isValidSelectedDealer = false;
    $scope.isValidPayment = false;
    $scope.isValidSummary = false;
    $scope.axaptaConsumerAccountNumber = '';
    $scope.checkTermsAndConditions = false;
    $scope.checkPrivacy = null;
    $scope.paymentKey = '';
    $scope.cardholderName = '';
    $scope.expirationDate = '';
    $scope.last4Digits = '';
    $scope.creditcardType = '';
    $scope.proceedPaymentButtonClicked = false;
    $scope.proceedContactInfoButtonClicked = false;
    $scope.proceedLoginButtonClicked = false;
    $scope.proceedShippingOptionButtonClicked = false;
    $scope.proceedSelectDealerButtonClicked = false;
    $scope.proceedSummaryButtonClicked = false;
    $scope.ShippingOption = {};
    $scope.Cart = {};
    $scope.Cart.Loaded = false;
    $scope.totalPriceWithTaxAndShipping = 0;
    $scope.OutOfStockValidation = {};
    $scope.lockedCart = '';
    $scope.issuer = '';
    $scope.employeeNumber = '';
    $scope.IOS = false;
    $scope.showPersonalData = false;
    //$scope.V12FinanceProduct = {
    //    Selected: '',
    //    DepositValue: 250,
    //    changeDepositValue: function () {
    //        if ($scope.V12FinanceProduct.DepositValue < $scope.V12Slider.options.minLimit) {
    //            $scope.V12FinanceProduct.DepositValue = $scope.V12Slider.options.minLimit;
    //        } else if ($scope.V12FinanceProduct.DepositValue > $scope.V12Slider.options.maxLimit) {
    //            $scope.V12FinanceProduct.DepositValue = $scope.V12Slider.options.maxLimit;
    //        }
    //    },
    //    CalculateV12: function (product) {
    //        var purchaseValue = $scope.Cart.TotalIncludingShippingCosts;

    //        var monthlypaymentResult = parseFloat((purchaseValue - $scope.V12FinanceProduct.DepositValue) * product.CalculationFactor);
    //        return monthlypaymentResult.toFixed(2);
    //    }
    //};
    $scope.slider = '';
    $scope.couponcode = '';
    $scope.coupon = null;
    $scope.promotion = null;
    $scope.showPasswordForgotten = false;
    $scope.imagesToPartnumbers = [];
    $scope.color = '';
    $scope.colors = [];
    $scope.partnumbers = [];
    $scope.stocks = [];
    $scope.stock = {};
    $scope.product = {};
    //$scope.commerzFinanzLabel = '';
    $scope.consorsFinanzLabel = '';
    //$scope.v12FinanceProducts = [];
    //$scope.v12Label = '';
    $scope.OrderConfirmation = '';
    $scope.countryId = countryId;
    $scope.onelineSizerProductFound = false;
    $scope.containsValidAddress = true;
    $scope.GAclientId = function () {
        var ga_clientId;
        try {
            if (ga.getAll()[0].get('clientId') != undefined) {
                ga_clientId = ga.getAll()[0].get('clientId');
            }
        } catch (e) {
            //do nothing
        }
        return ga_clientId;
    }
    //$scope.slickConfig = {
    //    enabled: true,
    //    autoplay: true,
    //    draggable: false,
    //    autoplaySpeed: 3000,
    //    method: {},
    //    event: {
    //        beforeChange: function (event, slick, currentSlide, nextSlide) {
    //        },
    //        afterChange: function (event, slick, currentSlide, nextSlide) {
    //        }
    //    }
    //};
    $scope.supplementaryItemPartnumberCode = '';
    $scope.availableStatesUSA = [
        { key: 'AL', value: 'Alabama' },
        { key: 'AK', value: 'Alaska' },
        { key: 'AZ', value: 'Arizona' },
        { key: 'AR', value: 'Arkansas' },
        { key: 'CA', value: 'California' },
        { key: 'CO', value: 'Colorado' },
        { key: 'CT', value: 'Connecticut' },
        { key: 'DE', value: 'Delaware' },
        { key: 'DC', value: 'District of Columbia' },
        { key: 'FL', value: 'Florida' },
        { key: 'GA', value: 'Georgia' },
        { key: 'HI', value: 'Hawaii' },
        { key: 'ID', value: 'Idaho' },
        { key: 'IL', value: 'Illinois' },
        { key: 'IN', value: 'Indiana' },
        { key: 'IA', value: 'Iowa' },
        { key: 'KS', value: 'Kansas' },
        { key: 'KY', value: 'Kentucky' },
        { key: 'LA', value: 'Louisiana' },
        { key: 'ME', value: 'Maine' },
        { key: 'MD', value: 'Maryland' },
        { key: 'MA', value: 'Massachusetts' },
        { key: 'MI', value: 'Michigan' },
        { key: 'MN', value: 'Minnesota' },
        { key: 'MS', value: 'Mississippi' },
        { key: 'MO', value: 'Missouri' },
        { key: 'MT', value: 'Montana' },
        { key: 'NE', value: 'Nebraska' },
        { key: 'NV', value: 'Nevada' },
        { key: 'NH', value: 'New Hampshire' },
        { key: 'NJ', value: 'New Jersey' },
        { key: 'NM', value: 'New Mexico' },
        { key: 'NY', value: 'New York' },
        { key: 'NC', value: 'North Carolina' },
        { key: 'ND', value: 'North Dakota' },
        { key: 'OH', value: 'Ohio' },
        { key: 'OK', value: 'Oklahoma' },
        { key: 'OR', value: 'Oregon' },
        { key: 'PA', value: 'Pennsylvania' },
        { key: 'PR', value: 'Puerto Rico' },
        { key: 'RI', value: 'Rhode Island' },
        { key: 'SC', value: 'South Carolina' },
        { key: 'SD', value: 'South Dakota' },
        { key: 'TN', value: 'Tennessee' },
        { key: 'TX', value: 'Texas' },
        { key: 'UT', value: 'Utah' },
        { key: 'VT', value: 'Vermont' },
        { key: 'VA', value: 'Virginia' },
        { key: 'WA', value: 'Washington' },
        { key: 'WV', value: 'West Virginia' },
        { key: 'WI', value: 'Wisconsin' },
        { key: 'WY', value: 'Wyoming' }
    ];

    $scope.availableStatesCA = [
        { key: 'AB', value: 'Alberta' },
        { key: 'BC', value: 'British Columbia' },
        { key: 'MB', value: 'Manitoba' },
        { key: 'NB', value: 'New Brunswick' },
        { key: 'NL', value: 'Newfoundland and Labrador' },
        { key: 'NS', value: 'Nova Scotia' },
        { key: 'NT', value: 'Northwest Territories' },
        { key: 'NU', value: 'Nunavut' },
        { key: 'ON', value: 'Ontario' },
        { key: 'PE', value: 'Prince Edward Island' },
        { key: 'QC', value: 'Quebec' },
        { key: 'SK', value: 'Saskatchewan' },
        { key: 'YT', value: 'Yukon' }
    ];

    $scope.creditcardAddress = {
        useShippingAddress: false,
        name: '',
        street: '',
        zipcode: '',
        city: '',
        state: ''
    };
    $scope.completeInProgress = '';

    $scope.simplefyCCNumberValid = false;
    $scope.simplefyCVVCodeValid = false;
    $scope.simplefyExpValid = false;
    $scope.simplefyValid = function () {
        return $scope.simplefyCCNumberValid && $scope.simplefyCVVCodeValid && $scope.simplefyExpValid;
    };

    $scope.toggleUseShippingAddress = function () {
        if ($scope.creditcardAddress.useShippingAddress) {
            if ($scope.firstname != undefined) {
                $scope.creditcardAddress.name = $scope.firstname + ' ' + $scope.lastname;
                $scope.creditcardAddress.street = $scope.street;
                $scope.creditcardAddress.zipcode = $scope.postalcode;
                $scope.creditcardAddress.city = $scope.city;
                $scope.creditcardAddress.state = $scope.state;
            } else {
                //nieuwe manier
                $scope.creditcardAddress.name = $scope.Cart.Order.Firstname + ' ' + $scope.Cart.Order.Lastname;
                $scope.creditcardAddress.street = $scope.Cart.Order.Street;
                $scope.creditcardAddress.zipcode = $scope.Cart.Order.Postalcode;
                $scope.creditcardAddress.city = $scope.Cart.Order.City;
                $scope.creditcardAddress.state = $scope.Cart.Order.State;
            }
        } else {
            $scope.creditcardAddress.name = '';
            $scope.creditcardAddress.street = '';
            $scope.creditcardAddress.zipcode = '';
            $scope.creditcardAddress.city = '';
            $scope.creditcardAddress.state = '';
        }
    };

    //$scope.V12Slider = {
    //    //value: function () {
    //    //    return $scope.Cart.TotalIncludingShippingCosts * 0.1;
    //    //},
    //    options: {
    //        step: 1,
    //        translate: function (value) {
    //            return '£' + value;
    //        },
    //        showSelectionBar: true,
    //        getSelectionBarColor: function (value) {
    //            return '#0DB9F0';
    //        }
    //    }
    //};

    //$scope.initiateV12Slider = function () {
    //    $timeout(function () {
    //        if ($scope.Cart == undefined || $scope.Cart.length == 0) {
    //            $scope.Cart = {};
    //            $scope.Cart.TotalIncludingShippingCosts = $scope.partnumbers[0].price;
    //            $scope.Cart.V12FinanceProducts = $scope.v12FinanceProducts;
    //        }
    //        $scope.$broadcast('rzSliderForceRender');
    //        $scope.V12FinanceProduct.DepositValue = Math.round($scope.Cart.TotalIncludingShippingCosts * 0.1);
    //        $scope.V12Slider.options.ceil = Math.round($scope.Cart.TotalIncludingShippingCosts * 0.5);
    //        $scope.V12Slider.options.floor = Math.round($scope.Cart.TotalIncludingShippingCosts * 0.1);
    //        $scope.V12Slider.options.minLimit = Math.round($scope.Cart.TotalIncludingShippingCosts * 0.1);
    //        $scope.V12Slider.value = Math.round($scope.Cart.TotalIncludingShippingCosts * 0.1);
    //    });
    //}

    $scope.getDealers = function (localstockonly, callback, startNew) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/dealers' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');

            if (localstockonly != undefined) {
                $scope.localstockonly = localstockonly;
            }
            if (startNew != undefined) {
                $scope.skip = 0;
            }
            $http({
                method: 'POST',
                url: url,
                data: {
                    partnumberCode: $scope.partnumber.code != undefined ? $scope.partnumber.code : null,
                    localstockOnly: $scope.localstockonly,
                    productType: $window.productTypeId != undefined ? $window.productTypeId : null,
                    productId: $window.productId != undefined ? $window.productId : null,
                    latitude: $scope.latitude,
                    longitude: $scope.longitude,
                    city: $scope.dealercity,
                    take: $scope.take,
                    skip: $scope.skip
                },
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        if (obj[p] != null) {
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        }
                    return str.join("&");
                },
                withCredentials: true
            }).then(function (res) {
                if (startNew != undefined && startNew == true) {
                    $scope.dealers = res.data.dealers;
                } else {
                    $scope.dealers = $scope.dealers.concat(res.data.dealers);
                }
                $scope.localstockDealers = res.data.localstockDealers;
                $scope.dealercity = res.data.city;
                $scope.productTypeId = res.data.productTypeId;
                if (res.data.productId > 0) {
                    $scope.productId = res.data.productId;
                } else {
                    try {
                        $scope.productId = productId;
                    } catch (e) {
                        //do nothing
                    }
                }
                $scope.total = res.data.total;
                $scope.nowarehousestock = res.data.nowarehousestock;
                $scope.containsLocalstock = res.data.containsLocalstock;
                if (res.data.lockedCart != undefined) {
                    $scope.lockedCart = res.data.lockedCart;
                }

                if (callback) {
                    callback();
                }

                /*
                SK+NS: switched off 19-08-2019
                if (helpers.isMobile())
                    $timeout(function () {
                        $document.find('#localstockContainer').scrollToElement({ marginTop: $document.find('#clickandcollect').offset().top - 80 });
                    });
                */

            });
        });
    }

    $scope.getLocalDealers = function () {
        //Supplementary items doesn't support local dealer stock
        if ($scope.Cart.HasSupplementaryItems == undefined || $scope.Cart.HasSupplementaryItems == false) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/dealers' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');

                $http({
                    method: 'POST',
                    url: url,
                    data: {
                        partnumberCode: $scope.partnumber.code != undefined ? $scope.partnumber.code : null,
                        localstockOnly: true,
                        productType: $window.productTypeId != undefined ? $window.productTypeId : null,
                        productId: $window.productId != undefined ? $window.productId : null,
                        latitude: $scope.latitude,
                        longitude: $scope.longitude,
                        city: $scope.dealercity
                    },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            if (obj[p] != null) {
                                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                            }
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    $scope.localdealers = res.data.dealers;
                    if (res.data.lockedCart != undefined) {
                        $scope.lockedCart = res.data.lockedCart;
                    }

                    $scope.productTypeId = res.data.productTypeId;
                    if (res.data.productId > 0) {
                        $scope.productId = res.data.productId;
                    } else {
                        try {
                            $scope.productId = productId;
                        } catch (e) {
                            //do nothing
                        }
                    }

                    /*
                    SK+NS: switched off 19-08-2019
                    if (helpers.isMobile())
                        $timeout(function () {
                            $document.find('#localstockContainer').scrollToElement({ marginTop: $document.find('#clickandcollect').offset().top - 80 });
                        });
                    */
                });
            });
        }
    }

    $scope.showMoreDealers = function () {
        $scope.skip = $scope.skip + $scope.take;
        $scope.getDealers();
    }

    $scope.showMoreDealersLink = function () {
        if (($scope.skip + $scope.take) < $scope.total) {
            return true;
        } else {
            return false;
        }
    }

    $scope.resetDealers = function () {
        $scope.skip = 0;
        $scope.dealers = [];
    }

    $scope.selectSize = function (code, stock, productTypeId, notifyMe, shippingcosts) {
        if (productTypeId != undefined && productTypeId == 1) {
            $scope.partnumber = {
                code: code,
                stock: stock,
                type: productTypeId,
                shippingcosts: shippingcosts,
                notifyMe: notifyMe
            };
            //$scope.resetDealers();
            $scope.getLocalDealers();
            $scope.getDealers(null, null, true);
        }
    }

    $scope.selectColor = function (nrOfSizes) {
        code = $("#colorSelector").find(':selected').attr('data-partnumbercode');
        stock = $("#colorSelector").find(':selected').attr('data-stockcode');

        var imagesToPartnumbers = helpers.getImagesToPartnumbers();
        if (imagesToPartnumbers.length > 0) {

            imagesToPartnumbers = imagesToPartnumbers.filter(function (image) {
                if (image.PartnumberCodes.indexOf(code) != -1) {
                    return image;
                }
            });

            if (imagesToPartnumbers.length > 0) {
                var images = $("img[name='mainImage']");
                if (images.length > 0) {
                    for (i = 0; i < images.length; i++) {
                        var imageSrc = images[i].src;
                        images[i].src = imageSrc.replace(imageSrc.substr(imageSrc.lastIndexOf('/') + 1), imagesToPartnumbers[0].CloudinaryImage);
                    }
                }
            }
        }

        if (nrOfSizes != undefined && nrOfSizes == 1) {
            $scope.partnumber = {
                code: code,
                stock: stock,
                type: $window.productTypeId
            };

            //$scope.resetDealers();
            $scope.getLocalDealers();
            $scope.getDealers(null, null, true);
        }
    }

    $scope.getDealersFiltered = function (limit, maxdistance) {
        var result = $scope.localdealers;
        if (maxdistance > 0 | limit > 0) {
            if ($scope.partnumber != null && $scope.partnumber.stock != undefined && ($scope.partnumber.stock == 'instock' || $scope.partnumber.stock.Code == 1 || $scope.partnumber.stock.Code == 3)) {
                result = [];
                for (var i = 0; i < $scope.localdealers.length; i++) {
                    if ($scope.localdealers[i].Distance <= maxdistance) {
                        result.push($scope.localdealers[i]);
                    }
                }
            }
            if (limit > 0) {
                result = result.slice(0, limit);
            }
            $scope.localdealersCountFiltered = result.length;
        }
        return result;
    }

    $scope.getOpeningHours = function (dealer) {
        return $sce.trustAsHtml(dealer.Openinghours);
    };

    $scope.parseHtml = function (html) {
        return $sce.trustAsHtml(html);
    };

    $scope.getGeolocation = function (callback) {
        helpers.getGeolocation($scope.dealercity, function (lat, lng) {
            $scope.latitude = lat;
            $scope.longitude = lng;
            if (callback) {
                callback();
            }
        });
    };

    $scope.getGeolocationAndGetDealers = function (callback) {
        $scope.getGeolocation(function () {
            //$scope.resetDealers();
            $scope.getDealers(null, callback, true);
            $scope.getLocalDealers();
        });
    }

    $scope.getBrowserlocationAndGetDealers = function () {
        helpers.getBrowserLocation(function (lat, lng, dealercity) {
            //$scope.resetDealers();
            $scope.latitude = lat;
            $scope.longitude = lng;
            $scope.dealercity = dealercity;
            $scope.getDealers(null, null, true);
            $scope.getLocalDealers();
        });
    }

    $scope.hasLocalStock = function (dealer) {
        var result = false;

        for (var i = 0; i < $scope.localstockDealers.length; i++) {
            if ($scope.localstockDealers[i] == dealer.Code) {
                result = true;
                break;
            }
        }

        return result;
    }

    $scope.showGoogleMaps = function (dealer, viewMode) {

        setTimeout(function () {
            var myLatLng = new google.maps.LatLng(dealer.Latitude, dealer.Longitude);
            var bounds = new google.maps.LatLngBounds();
            var mapOptions = {
                center: myLatLng,
                zoom: 10,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            }

            var mapCanvas = document.getElementById('map-canvas-' + viewMode + '-' + dealer.Code);
            var map = new google.maps.Map(mapCanvas, mapOptions);
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map
            });
            bounds.extend(marker.getPosition());
            google.maps.event.trigger(map, "resize");
        });
    }

    $scope.showStockAlert = function () {
        $('#stockAlertModal #partnumberCode').val($scope.partnumber.code);
        $('#stockAlertModal').modal('show');
    }

    $scope.showContactForm = function () {
        $('#contactModal').modal('show');
    }

    $scope.outOfStockValidation = function () {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/outofstockvalidation' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $scope.OutOfStockValidation = res.data;
                $scope.errorPayment = '';
                if ($scope.OutOfStockValidation.Message != null) {
                    $scope.errorPayment = $scope.OutOfStockValidation.Message;
                }
            });
        });
    }

    $scope.updateCart = function (callback, initiator) {
        cartService.getCart(initiator).then(function () {
            $scope.Cart = cartService._cart;
            $scope.Cart.Loaded = true;
            $scope.totalPriceWithTaxAndShipping = $scope.Cart.TotalIncludingShippingCosts;

            if ($scope.Cart.ShippingOptions != undefined && $scope.Cart.ShippingOptions.length > 0) {
                $scope.ShippingOption.selected = $scope.Cart.ShippingOptions.filter(function (value) { return value.Guid == $scope.Cart.ShippingGuid && value.Disabled == false })[0];
            }

            if ($scope.Cart.Order != null && $scope.Cart.Order.Email != null && $scope.Cart.Order.Email.length > 0) {
                $scope.showPersonalData = true;
            }

            if ($('.affirm-as-low-as').length > 0) {
                //    //update Affirm value
                try {
                    affirm.ui.ready(function () {
                        affirm.ui.refresh();
                    });
                } catch (e) {
                    //do nothing
                }
            }

            if ($scope.Cart.PaymentOptions != undefined && $scope.Cart.PaymentOptions.length == 1) {
                $scope.selectPaymentOption($scope.Cart.PaymentOptions[0].code)
            }

            if ($scope.Cart.Coupon != undefined) {
                $scope.coupon = $scope.Cart.Coupon;
            }

            if ($scope.Cart.Promotion != undefined) {
                $scope.promotion = $scope.Cart.Promotion;
            }

            $scope.validateAddress();

            if (callback) {
                callback();
            }
        })
    }

    $scope.removeCartItem = function (item) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/removecartitem/' + item.Product.Partnumber.Code.toLowerCase() + '/json?expanded=true&r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $scope.updateCart(function () {
                    //Opnieuw out of stock bepalen. Zodat melding weg is.
                    $scope.outOfStockValidation();
                }, 'RemoveCartItem');
                $rootScope.$broadcast('cartUpdated');
                $scope.isValidContactInfo = false;
                $scope.isValidShippingOption = false;
                $scope.isValidSelectedDealer = false;
                $scope.isValidPayment = false;
                $scope.isValidSummary = false;
                $('#collapseContactInfo').collapse('show');
                $('#collapseShippingOptions').collapse('hide');
                $('#collapseDealers').collapse('hide');
                $('#collapsePayment').collapse('hide');
                $('#collapseSummary').collapse('hide');
            });
        });
    }

    $scope.removeDealer = function () {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/removedealer?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $scope.updateCart(null, 'RemoveDealer');
                $scope.isValidContactInfo = false;
                $scope.isValidShippingOption = false;
                $scope.isValidSelectedDealer = false;
                $scope.isValidPayment = false;
                $scope.isValidSummary = false;
                $('#collapseContactInfo').collapse('show');
                $('#collapseShippingOptions').collapse('hide');
                $('#collapseDealers').collapse('hide');
                $('#collapsePayment').collapse('hide');
                $('#collapseSummary').collapse('hide');
            });
        });
    }

    $scope.showDealerSelector = function () {
        return ($scope.countryId == 19 || $scope.countryId == 48 || $scope.countryId == 6 || $scope.countryId == 8 || $scope.countryId == 29 || $scope.countryId == 14 || $scope.countryId == 15 || $scope.countryId == 17 || ($scope.Cart.ContainsOnlyGear == false && ($scope.ShippingOption.selected != null && $scope.ShippingOption.selected.OnlyDirectshipmentBikes == false))) && ($scope.Cart.Dealer == null || $scope.isValidSelectedDealer == true);
    }

    $scope.ValidatedAddressAtGoogleMaps = false;
    $scope.ValidateAddressAtGoogleMaps = function () {
        getLatLng($scope.Cart.Order.Street + ' ' + $scope.Cart.Order.Postalcode + ' ' + $scope.Cart.Order.City + ' ' + country, function (a, b, c, d) {
            try {
                for (var i = 0; i < d[0].address_components.length; i++) {
                    if (d[0].address_components[i].types[0] == 'country') {
                        if (d[0].address_components[i].short_name.toLowerCase() == countryCode) {
                            $scope.ValidatedAddressAtGoogleMaps = true;
                            $scope.$apply();
                            $scope.proceedContactInfoAfterValidation();
                            return true;
                        }
                    }
                }
            } catch (e) {
                exceptionHandling(e.message, e.stack);
            }
            exceptionHandling('Cart contains address different from country', 'Google Maps input: ' + $scope.Cart.Order.Street + ' ' + $scope.Cart.Order.Postalcode + ' ' + $scope.Cart.Order.City + ' ' + country + '\nGoogle Maps result: ' + c);
            $scope.ValidatedAddressAtGoogleMaps = true;
            $scope.errorContactInfo = lblIncorrectAddress;
            $scope.proceedContactInfoButtonClicked = false;
            $scope.$apply();
            return false;
        });
    }

    $scope.proceedContactInfo = function () {
        //check required fields
        $scope.errorContactInfo = '';
        $scope.proceedContactInfoButtonClicked = true;
        if ($scope.formContactInfo.$valid) {
            if ($scope.ValidatedAddressAtGoogleMaps == false && window.validateAddressAtGoogleMaps != undefined && window.validateAddressAtGoogleMaps == true) {
                $scope.ValidateAddressAtGoogleMaps();
            } else {
                $scope.proceedContactInfoAfterValidation();
            }
        } else {
            if ($scope.formContactInfo.$error.required != undefined && $scope.formContactInfo.$error.required.length > 0) {
                $scope.errorContactInfo += lblMakeSureAllRequiredFieldsAreEntered;
            }
            if ($scope.formContactInfo.$error.email != undefined && $scope.formContactInfo.$error.email.length > 0) {
                $scope.errorContactInfo += lblWrongEmailHasBeenEntered;
            }
        }
    }

    $scope.proceedContactInfoAfterValidation = function () {
        $scope.contactinfoHTML = '';
        $scope.dealercity = $scope.postalcode + ' ' + $scope.city;
        var search = $scope.street + ' ' + $scope.postalcode + ' ' + $scope.city + ',' + country;
        if ($scope.state != undefined) {
            $scope.dealercity += ', ' + $scope.state;
        }

        //if (version != undefined && version == 2) {
        $scope.dealercity = $scope.Cart.Order.Street + ' ' + $scope.Cart.Order.Postalcode + ' ' + $scope.Cart.Order.City;
        if ($scope.Cart.Order.State != undefined) {
            $scope.dealercity += ', ' + $scope.Cart.Order.State;
        }
        search = $scope.Cart.Order.Street + ' ' + $scope.Cart.Order.Postalcode + ' ' + $scope.Cart.Order.City + ',' + country;
        //}

        getLatLng(search, function (lat, lng, formatted_address) {
            $('#Order_OrderLatitude').val(lat);
            $('#Order_OrderLongitude').val(lng);
            $('#Order_OrderGAclientId').val($scope.GAclientId());

            //submit form to collect contact info
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setcontactinfo' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                $http({
                    method: 'POST',
                    url: url,
                    data: $('form[name="formOrder"]').serialize(),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    withCredentials: true
                }).then(function (res) {
                    $scope.isValidContactInfo = res.data.result;
                    $scope.isValidShippingOption = false;
                    $scope.isValidSelectedDealer = false;
                    $scope.isValidPayment = false;
                    $scope.isValidSummary = false;
                    if (res.data.result == true) {
                        $scope.contactinfoHTML = $sce.trustAsHtml(res.data.html);
                        $scope.axaptaConsumerAccountNumber = res.data.axaptaConsumerAccountNumber;
                        $scope.proceedContactInfoButtonClicked = false;
                        $scope.updateCart(function () {
                            $('#collapseShippingOptions').collapse('show');
                            $('#collapseContactInfo').collapse('hide');
                        }, 'SetContactInfo'); //especially for gear items. Tax will change.

                        $analytics.createBuilder().asCheckoutStep({
                            step: 1,
                            option: $scope.axaptaConsumerAccountNumber === '' ? 'NotLoggedIn' : 'LoggedIn'
                        }).send();
                    } else {
                        $scope.errorContactInfo = res.data.error;
                        $('#collapseShippingOptions').collapse('hide');
                    }
                });
            });
        });

    }

    $scope.Login = function () {
        accountService.Login($scope.loginEmail, $scope.loginPassword, true).then(function () {
            if (accountService._account.result != null && accountService._account.result.Token.length > 0) {
                $scope.Cart.Order.Firstname = accountService._account.result.Details.OrderFirstname;
                $scope.Cart.Order.Lastname = accountService._account.result.Details.OrderLastname;
                $scope.Cart.Order.Street = accountService._account.result.Details.OrderStreet;
                $scope.Cart.Order.OrderAddress2 = accountService._account.result.Details.OrderAddress2;
                $scope.Cart.Order.Postalcode = accountService._account.result.Details.OrderPostalcode;
                $scope.Cart.Order.City = accountService._account.result.Details.OrderCity;
                $scope.Cart.Order.State = accountService._account.result.Details.OrderState;
                $scope.Cart.Order.Phone = accountService._account.result.Details.OrderPhone;
                $scope.Cart.Order.Email = accountService._account.result.Details.OrderEmail;
                $scope.Cart.Order.AxaptaConsumerAccountNumber = accountService._account.result.Details.OrderAxaptaConsumerAccountNumber;
                $scope.Cart.Order.Gender = accountService._account.result.Details.GenderToFormat;
                $scope.Cart.Order.BirthDate = accountService._account.result.Details.BirthDateToFormat;
                $scope.Cart.Order.AddToNewsletter = accountService._account.result.Details.OrderAddToNewsletter;
                $scope.showPersonalData = true;
                $scope.validateAddress();
            } else {
                try {
                    $scope.errorLogin = accountService._account.error;
                } catch (e) {
                    $scope.errorLogin = 'An error occurred. Please try again';
                }
            }
        });
    }

    $scope.proceedLogin = function () {
        $scope.errorLogin = '';
        $scope.proceedLoginButtonClicked = true;

        if ($scope.formLogin.$valid) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/login' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                $http({
                    method: 'POST',
                    url: url,
                    data: { email: $scope.loginEmail, password: $scope.loginPassword },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    if (res.data.error.length == 0) {
                        //if (version != undefined && version == 2) {
                        $scope.Cart.Order.Firstname = res.data.result.OrderFirstname;
                        $scope.Cart.Order.Lastname = res.data.result.OrderLastname;
                        $scope.Cart.Order.Street = res.data.result.OrderStreet;
                        $scope.Cart.Order.OrderAddress2 = res.data.result.OrderAddress2;
                        $scope.Cart.Order.Postalcode = res.data.result.OrderPostalcode;
                        $scope.Cart.Order.City = res.data.result.OrderCity;
                        $scope.Cart.Order.State = res.data.result.OrderState;
                        $scope.Cart.Order.Phone = res.data.result.OrderPhone;
                        $scope.Cart.Order.Email = res.data.result.OrderEmail;
                        $scope.Cart.Order.AxaptaConsumerAccountNumber = res.data.result.OrderAxaptaConsumerAccountNumber;

                        $('#loginModal').modal('hide');
                        //rename create account label
                        //$('#lnkCreateAccount').html(lblChangePassword);
                        $scope.errorLogin = '';
                        $scope.proceedLoginButtonClicked = false;
                    } else {
                        $scope.errorLogin = res.data.error;
                    }
                });
            });
        } else {
            if ($scope.formLogin.$error.required != undefined && $scope.formLogin.$error.required.length > 0) {
                $scope.errorLogin = lblMakeSureAllRequiredFieldsAreEntered;
            }
            if ($scope.formLogin.$error.email != undefined && $scope.formLogin.$error.email.length > 0) {
                $scope.errorLogin += lblWrongEmailHasBeenEntered;
            }
        }
    }

    $scope.Logout = function () {
        accountService.Logout();
        //location.reload();
        //$scope.resetContactInfo();
    }

    $scope.proceedPasswordForgotten = function () {
        $http({
            method: 'POST',
            url: '/' + $window.culture + '/shop/resetpasswordrequest' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : ''),
            data: { email: $scope.loginEmail }
        }).then(function (res) {
            $scope.messagePasswordForgotten = '';
            $scope.errorPasswordForgotten = '';
            if (res.data.result == true) {
                $scope.messagePasswordForgotten = res.data.message;
            } else {
                $scope.errorPasswordForgotten = res.data.message;
            }
        });
    }

    $scope.selectShippingOption = function () {
        //var shippingOptionSelected = $scope.ShippingOption.selected;
        //if (shippingOptionSelected.OnlyDirectshipmentBikes == true) {
        //    $('#panel-dealerselector').hide();
        //    //$('#headingPayment .nr').text(parseInt($('#headingShippingOptions .nr').text()) + 1);
        //} else {
        //    $('#panel-dealerselector').show();
        //    //$('#headingPayment .nr').text(parseInt($('#headingShippingOptions .nr').text()) + 2);
        //}
    };

    $scope.proceedShippingOption = function () {
        $scope.errorShippingOption = '';
        $scope.proceedShippingOptionButtonClicked = true;
        var shippingOptionSelected = $scope.ShippingOption.selected;

        if (shippingOptionSelected != null) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setshippingoption' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                $http({
                    method: 'POST',
                    url: url,
                    data: { guid: shippingOptionSelected.Guid },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    $scope.isValidShippingOption = res.data;
                    $scope.isValidSelectedDealer = false;
                    $scope.isValidPayment = false;
                    $scope.isValidSummary = false;
                    //if (version != undefined && version == 2) {
                    if (shippingOptionSelected.DeliveryTypeToString == 'homedelivery' && $scope.Cart.UseLocalStock != undefined && $scope.Cart.UseLocalStock == false && $scope.Cart.Dealer != null) {
                        //remove dealer when switching to homedelivery and not local stock
                        $scope.removeDealer();
                    }

                    //if (shippingOptionSelected.DeliveryTypeToString == 'homedelivery') {
                    //set search dealer field at home address
                    $scope.dealercity = $scope.Cart.Order.Street + ' ' + $scope.Cart.Order.Postalcode + ' ' + $scope.Cart.Order.City;
                    //}
                    //} else {
                    //    if (shippingOptionSelected.DeliveryTypeToString == 'homedelivery' && localstock != undefined && localstock == false && $('#dealerSelected').length > 0 && $('#dealerSelected').val() == 'true') {
                    //        //remove dealer when switching to homedelivery and not local stock
                    //        window.location = '/' + culture + '/shop/removedealercode';
                    //    }

                    //    if (shippingOptionSelected.DeliveryTypeToString == 'homedelivery') {
                    //        //set search dealer field at home address
                    //        $scope.dealercity = $scope.street + ' ' + $scope.postalcode + ' ' + $scope.city;
                    //    }
                    //}

                    //UpdateCart();
                    $scope.updateCart(null, 'SetShippingOption');

                    $analytics.createBuilder().asCheckoutStep({
                        step: 2,
                        option: shippingOptionSelected.DeliveryTypeToString
                    }).send();

                    if ($('#panel-dealerselector').is(":visible")) {
                        $scope.getGeolocationAndGetDealers(function () {
                            $('#collapseDealers').collapse('show');
                            $('#collapseShippingOptions').collapse('hide');
                            $scope.proceedShippingOptionButtonClicked = false;
                        });
                    } else {
                        $('#collapsePayment').collapse('show');
                        $('#collapseShippingOptions').collapse('hide');
                        $scope.proceedShippingOptionButtonClicked = false;
                    }
                    $scope.isIOS();
                });
            });
        } else {
            $scope.errorShippingOption = lblSelectDeliveryOption;
        }
    }

    $scope.proceedSelectDealer = function (dealer) {
        $scope.proceedSelectDealerButtonClicked = dealer.Code;
        $scope.errorDealerSelect = '';

        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/setdealercode' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'POST',
                url: url,
                data: { dealercode: dealer.Code },
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                withCredentials: true
            }).then(function (res) {
                if (res.data == 'True') {
                    $scope.updateCart(function () {
                        $('#collapsePayment').collapse('show');
                        $('#collapseDealers').collapse('hide');
                        $scope.isValidSelectedDealer = true;
                        $scope.isValidPayment = false;
                        $scope.isValidSummary = false;
                        $scope.proceedSelectDealerButtonClicked = false;
                        $scope.outOfStockValidation();
                    }, 'SetDealerCode');

                    if ($scope.hasLocalStock(dealer)) {
                        //double check product is in local stock. Else show user message product is only in warehouse stock.
                        $scope.outOfStockValidation();
                    }
                } else {
                    $scope.errorDealerSelect = res.data;
                    $scope.proceedSelectDealerButtonClicked = '';
                }

                $scope.isIOS();
            });
        });
    }

    $scope.selectPaymentOption = function (paymentOption) {
        if (paymentOption != undefined) {
            $scope.paymentoption = paymentOption;
        }
        //if ($scope.paymentoption == 'v12') {
        //    $scope.initiateV12Slider();
        //}
        if ($scope.paymentoption == 'klarna') {
            $scope.initiateKlarna();
        }
        if ($scope.paymentoption == 'simplefy') {
            $scope.initiateSimplefy();
        }
    }

    $scope.proceedPayment = function (isMobile) {
        var billingAddressValid = false;
        $scope.errorPayment = '';
        $scope.proceedPaymentButtonClicked = true;
        if (($scope.checkTermsAndConditions == true && ($scope.checkPrivacy == true || $scope.checkPrivacy == null)) || isMobile) {
            if ($scope.paymentoption != null) {
                if ($scope.paymentoption == 'stripe') {
                    if ($scope.formStripe.$valid) {
                        //all required fields have been entered. Create token.
                        // The billing address needs to be validated and saved for USA & Canada
                        if (countryId == 1 || countryId == 10 || countryId == 16) {
                            cartService.MasterDomain().then(function () {
                                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setbillingaddress' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                                $http({
                                    method: 'POST',
                                    url: url,
                                    data: $('form[name="formOrder"]').serialize(),
                                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                    withCredentials: true
                                }).then(function (res) {
                                    if (res.data.result == true) {
                                        _completeStripePayment(isMobile);
                                    } else {
                                        $scope.errorPayment = res.data.error;
                                        $scope.proceedPaymentButtonClicked = false;
                                    }
                                });
                            });
                        } else {
                            // Other countries don't have seperate fields for the billing address, we need to set the fields to the delivery address
                            $scope.creditcardAddress.name = $scope.Cart.Order.Firstname + ' ' + $scope.Cart.Order.Lastname;
                            $scope.creditcardAddress.street = $scope.Cart.Order.Street;
                            $scope.creditcardAddress.zipcode = $scope.Cart.Order.Postalcode;
                            $scope.creditcardAddress.city = $scope.Cart.Order.City;
                            $scope.creditcardAddress.state = $scope.Cart.Order.State;

                            _completeStripePayment(isMobile);
                        }
                    }
                    else {
                        if ($scope.formStripe.$error.required != undefined && $scope.formStripe.$error.required.length > 0) {
                            $scope.errorPayment = lblMakeSureAllRequiredFieldsAreEntered;
                        }
                    }
                }
                else if ($scope.paymentoption == 'stripe2') {
                    if ($scope.formStripe2.$valid) {
                        //all required fields have been entered. Create token.
                        // The billing address needs to be validated and saved for USA & Canada
                        if (countryId == 1 || countryId == 10 || countryId == 16) {
                            cartService.MasterDomain().then(function () {
                                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setbillingaddress' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                                $http({
                                    method: 'POST',
                                    url: url,
                                    data: $('form[name="formOrder"]').serialize(),
                                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                    withCredentials: true
                                }).then(function (res) {
                                    if (res.data.result == true) {
                                        if (!isMobile) {
                                            _completeStripePayment2();
                                        } else {
                                            $scope.proceedPaymentButtonClicked = false;
                                            $('#collapseSummary').collapse('show');
                                            $('#collapsePayment').collapse('hide');
                                        }
                                    } else {
                                        $scope.errorPayment = res.data.error;
                                        $scope.proceedPaymentButtonClicked = false;
                                    }
                                });
                            });
                        } else {
                            // Other countries don't have seperate fields for the billing address, we need to set the fields to the delivery address
                            $scope.creditcardAddress.name = $scope.Cart.Order.Firstname + ' ' + $scope.Cart.Order.Lastname;
                            $scope.creditcardAddress.street = $scope.Cart.Order.Street;
                            $scope.creditcardAddress.zipcode = $scope.Cart.Order.Postalcode;
                            $scope.creditcardAddress.city = $scope.Cart.Order.City;
                            $scope.creditcardAddress.state = $scope.Cart.Order.State;

                            if (!isMobile) {
                                _completeStripePayment2();
                            } else {
                                $scope.proceedPaymentButtonClicked = false;
                                $('#collapseSummary').collapse('show');
                                $('#collapsePayment').collapse('hide');
                            }
                        }
                    }
                    else {
                        if ($scope.formStripe2.$error.required != undefined && $scope.formStripe2.$error.required.length > 0) {
                            $scope.errorPayment = lblMakeSureAllRequiredFieldsAreEntered;
                        }
                    }
                }
                else if ($scope.paymentoption == 'simplefy') {
                    if ($scope.formSimplefy.$valid && $scope.simplefyValid()) {
                        //all required fields have been entered. Create token.
                        // The billing address needs to be validated and saved for USA & Canada
                        if (countryId == 1 || countryId == 10 || countryId == 16) {
                            cartService.MasterDomain().then(function () {
                                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setbillingaddress' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                                $http({
                                    method: 'POST',
                                    url: url,
                                    data: $('form[name="formOrder"]').serialize(),
                                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                    withCredentials: true
                                }).then(function (res) {
                                    if (res.data.result == true) {
                                        if (!isMobile) {
                                            _completeSimplefyPayment();
                                        } else {
                                            $scope.proceedPaymentButtonClicked = false;
                                            $('#collapseSummary').collapse('show');
                                            $('#collapsePayment').collapse('hide');
                                        }
                                    } else {
                                        $scope.errorPayment = res.data.error;
                                        $scope.proceedPaymentButtonClicked = false;
                                    }
                                });
                            });
                        } else {
                            // Other countries don't have seperate fields for the billing address, we need to set the fields to the delivery address
                            $scope.creditcardAddress.name = $scope.Cart.Order.Firstname + ' ' + $scope.Cart.Order.Lastname;
                            $scope.creditcardAddress.street = $scope.Cart.Order.Street;
                            $scope.creditcardAddress.zipcode = $scope.Cart.Order.Postalcode;
                            $scope.creditcardAddress.city = $scope.Cart.Order.City;
                            $scope.creditcardAddress.state = $scope.Cart.Order.State;

                            if (!isMobile) {
                                _completeSimplefyPayment();
                            } else {
                                $scope.proceedPaymentButtonClicked = false;
                                $('#collapseSummary').collapse('show');
                                $('#collapsePayment').collapse('hide');
                            }
                        }
                    }
                    else {
                        if ($scope.formSimplefy.$error.required != undefined && $scope.formSimplefy.$error.required.length > 0) {
                            $scope.errorPayment = lblMakeSureAllRequiredFieldsAreEntered;
                        } else if (!$scope.simplefyValid()) {
                            $scope.errorPayment = lblInvalidCreditCardInformation;
                        }
                    }
                }
                //else if ($scope.paymentoption == 'v12') {
                //    if ($scope.V12FinanceProduct.Selected != null && $scope.V12FinanceProduct.Selected.length > 0) {
                //        $scope.isValidPayment = true;
                //        $scope.isValidSummary = false;

                //        if (!isMobile) {
                //            $scope.SetV12Product(function () {
                //                $scope.completeOrder(function () {
                //                    $scope.isValidPayment = true;
                //                    $scope.proceedPaymentButtonClicked = false;
                //                });
                //            });
                //        } else {
                //            $scope.SetV12Product(function () {
                //                $scope.proceedPaymentButtonClicked = false;
                //                $('#collapseSummary').collapse('show');
                //                $('#collapsePayment').collapse('hide');
                //            });
                //        }
                //    } else {
                //        $scope.errorPayment = lblSelectFinanceOption;
                //    }
                //} else if ($scope.paymentoption == 'sts') {
                //    if ($scope.formSTS.$valid) {
                //        $scope.isValidPayment = true;
                //        $scope.isValidSummary = false;
                //        if (!isMobile) {
                //            $scope.completeOrder(function () {
                //                $scope.isValidPayment = true;
                //                $scope.proceedPaymentButtonClicked = false;
                //            });
                //        } else {
                //            $scope.proceedPaymentButtonClicked = false;
                //            $('#collapseSummary').collapse('show');
                //            $('#collapsePayment').collapse('hide');
                //        }
                //    } else {
                //        if ($scope.formSTS.$error.required != undefined && $scope.formSTS.$error.required.length > 0) {
                //            $scope.errorPayment = lblMakeSureAllRequiredFieldsAreEntered;
                //        }
                //    }
                //}
                else if ($scope.paymentoption == 'payeezy') {
                    if ($scope.formPayeezy.$valid) {
                        //all required fields have been entered. Create token.

                        // The billing address needs to be validated and saved for USA & Canada
                        if (countryId == 1 || countryId == 10 || countryId == 16) {
                            cartService.MasterDomain().then(function () {
                                var url = cartService._masterDomain + '/' + $window.culture + '/shop/setbillingaddress' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                                $http({
                                    method: 'POST',
                                    url: url,
                                    data: $('form[name="formOrder"]').serialize(),
                                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                    withCredentials: true
                                }).then(function (res) {
                                    if (res.data.result == true) {
                                        _completePayeezyPayment(isMobile);
                                    } else {
                                        $scope.errorPayment = res.data.error;
                                        $scope.proceedPaymentButtonClicked = false;
                                    }
                                });
                            });
                        } else {
                            // Other countries don't have seperate fields for the billing address, we need to set the fields to the delivery address
                            //if (version != undefined && version == 2) {
                            $scope.creditcardAddress.name = $scope.Cart.Order.Firstname + ' ' + $scope.Cart.Order.Lastname;
                            $scope.creditcardAddress.street = $scope.Cart.Order.Street;
                            $scope.creditcardAddress.zipcode = $scope.Cart.Order.Postalcode;
                            $scope.creditcardAddress.city = $scope.Cart.Order.City;
                            $scope.creditcardAddress.state = $scope.Cart.Order.State;
                            _completeStripePayment(isMobile);
                        }
                    }
                    else {
                        if ($scope.formPayeezy.$error.required != undefined && $scope.formPayeezy.$error.required.length > 0) {
                            $scope.errorPayment = lblMakeSureAllRequiredFieldsAreEntered;
                        }
                    }
                } else {
                    $scope.isValidPayment = true;
                    $scope.isValidSummary = false;
                    if (!isMobile) {
                        $scope.completeOrder(function () {
                            $scope.isValidPayment = true;
                            $scope.proceedPaymentButtonClicked = false;
                        });
                    } else {
                        $scope.proceedPaymentButtonClicked = false;
                        $('#collapseSummary').collapse('show');
                        $('#collapsePayment').collapse('hide');
                    }
                }
            } else {
                $scope.errorPayment = lblSelectPaymentOption;
            }
        } else {
            $scope.errorPayment = lblPleaseAgreeToTermsAndConditions;
        }
    }

    var _completeStripePayment = function (isMobile) {
        Stripe.card.createToken({
            number: $scope.creditcardnumber,
            cvc: $scope.cvc,
            exp_month: $scope.creditcardmonth,
            exp_year: $scope.creditcardyear,
            address_zip: $scope.creditcardAddress.zipcode,
            name: $scope.creditcardAddress.name,
            address_line1: $scope.creditcardAddress.street
        }, function (status, response) {
            if (response.error) {
                $scope.errorPayment = response.error.message;
                $scope.$apply();
            } else {
                $scope.paymentKey = response.id;
                $scope.$apply();
                if (!isMobile) {
                    $scope.completeOrder(function () {
                        $scope.isValidPayment = true;
                        $scope.isValidSummary = false;
                        $scope.proceedPaymentButtonClicked = false;
                    });
                } else {
                    $scope.isValidPayment = true;
                    $scope.isValidSummary = false;
                    $scope.proceedPaymentButtonClicked = false;
                    $scope.$apply();
                    $('#collapseSummary').collapse('show');
                    $('#collapsePayment').collapse('hide');
                }
            }
        });
    };

    var _completeStripePayment2 = function () {
        //var cardholderName = document.getElementById('Order.OrderBillingAddressName');
        //$scope.proceedSummaryButtonClicked = false;

        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/get-stripe-paymentintent?' + Math.random() + '&ga_clientId=' + $scope.GAclientId() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                if (res.data != null && res.data.success == true) {
                    stripe.handleCardPayment(
                        res.data.clientsecret, cardNumberElement, {
                        payment_method_data: {
                            billing_details: {
                                address: {
                                    city: $scope.creditcardAddress.city,
                                    //country: null,
                                    line1: $scope.creditcardAddress.street,
                                    postal_code: $scope.creditcardAddress.zipcode,
                                    state: $scope.creditcardAddress.state
                                },
                                email: $scope.Cart.Order.Email,
                                name: $scope.creditcardAddress.name
                            }
                        }
                    }
                    ).then(function (result) {
                        if (result.error) {
                            //unlock cart to continue checkout
                            $scope.unlockCart();
                            // Display error.message in your UI.
                            $scope.errorPayment = result.error.message;
                            $scope.$apply();
                        } else {
                            // The payment has succeeded. Display a success message.
                            $scope.completeOrder(function () {
                                $scope.isValidPayment = true;
                                $scope.isValidSummary = false;
                                $scope.proceedPaymentButtonClicked = false;
                            });
                        }
                    });
                } else {
                    $timeout(function () {
                        $scope.errorPayment = res.data.exception.Message != undefined ? res.data.exception.Message : res.data.exception;
                    });
                }
            })
        })
    };

    var _completeSimplefyPayment = function () {
        // Start the simplefy payment request. The code will continue in the callback of the CollectJS configure function (check initiateSimplefy function)
        CollectJS.startPaymentRequest();
    }

    var _completePayeezyPayment = function (isMobile) {
        $scope.errorPayment = '';
        //var $form = $scope.formPayeezy;
        var apiKey = document.getElementById("apikey").value;
        var js_security_key = document.getElementById("js_security_key").value;
        var auth = 'true';
        var ta_token = document.getElementById("ta_token").value;
        Payeezy.setApiKey(apiKey);
        Payeezy.setJs_Security_Key(js_security_key);
        Payeezy.setTa_token(ta_token);
        Payeezy.setAuth(auth);
        Payeezy.setCurrency('USD');
        Payeezy.createToken(function (status, response) {
            if (status != 201) {
                if (response.error && status != 400) {
                    var error = response["error"];
                    var errormsg = error["messages"];
                    var errorcode = JSON.stringify(errormsg[0].code, null, 4);
                    var errorMessages = JSON.stringify(errormsg[0].description, null, 4);
                    $scope.errorPayment = errorMessages;
                    $scope.$apply();
                }
                else {
                    //if (status == 400 || status == 500) {
                    var errorMessages = "";
                    for (var i in response.Error.messages) {
                        errorMessages += response.Error.messages[i].description + ' ';
                    }
                    $scope.errorPayment = errorMessages;
                    $scope.$apply();
                }

            } else {
                $scope.paymentKey = response.token.value;
                $scope.cardholderName = response.token.cardholder_name;
                $scope.expirationDate = response.token.exp_date;
                $scope.creditcardType = response.token.type;
                $scope.$apply();
                if (!isMobile) {
                    $scope.completeOrder(function () {
                        $scope.isValidPayment = true;
                        $scope.isValidSummary = false;
                        $scope.proceedPaymentButtonClicked = false;
                    });
                } else {
                    $scope.isValidPayment = true;
                    $scope.isValidSummary = false;
                    $scope.proceedPaymentButtonClicked = false;
                    $scope.$apply();
                    $('#collapseSummary').collapse('show');
                    $('#collapsePayment').collapse('hide');
                }
            }
        });
    };

    $scope.proceedSummary = function () {
        $scope.proceedSummaryButtonClicked = true;
        $scope.errorPayment = '';
        if ($scope.checkTermsAndConditions == true && ($scope.checkPrivacy == true || $scope.checkPrivacy == null)) {
            if ($scope.paymentoption == 'stripe2' && isMobile) {
                _completeStripePayment2(isMobile);
            } else {
                $scope.completeOrder(function () {
                    $scope.isValidSummary = true;
                    $scope.isValidSummary = false;
                    $scope.proceedSummaryButtonClicked = false;
                });
            }

        } else {
            $scope.errorPayment = lblPleaseAgreeToTermsAndConditions;
        }
    }

    $scope.collapseIsValid = function (collapseName) {
        //Check of all required fields have been set
        switch (collapseName) {
            case 'contactinfo':
                return $scope.isValidContactInfo;
            case 'shippingoptions':
                return $scope.isValidShippingOption;
            case 'dealers':
                return $scope.isValidSelectedDealer;
            case 'payment':
                return $scope.isValidPayment;
            case 'summary':
                return $scope.isValidSummary;
            default:
                return false;
        }
    }

    $scope.collapseIsAuthorizedToEdit = function (collapseName) {
        //Check of this collapse block can be opened when previous collapse blocks are valid
        switch (collapseName) {
            case 'contactinfo':
                return true;
            case 'shippingoptions':
                return $scope.collapseIsValid('contactinfo');
            case 'dealers':
                return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('shippingoptions');
            case 'payment':
                return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('shippingoptions') && $scope.collapseIsValid('dealers');
            case 'summary':
                return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('shippingoptions') && $scope.collapseIsValid('dealers') && $scope.collapseIsValid('payment');
            default:
                return false;
        }
    }

    //$scope.SetV12Product = function (callbackSuccess) {
    //    cartService.MasterDomain().then(function () {
    //        var url = cartService._masterDomain + '/' + $window.culture + '/shop/setv12product' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
    //        $http({
    //            method: 'POST',
    //            url: url,
    //            data: { productId: $scope.V12FinanceProduct.Selected, deposit: $scope.V12FinanceProduct.DepositValue },
    //            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    //            transformRequest: function (obj) {
    //                //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
    //                var str = [];
    //                for (var p in obj)
    //                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    //                return str.join("&");
    //            },
    //            withCredentials: true
    //        }).then(function (res) {
    //            if (res.data == true) {
    //                if (callbackSuccess) {
    //                    callbackSuccess();
    //                }
    //            }
    //        });
    //    });
    //}

    $scope.completeOrder = function (callbackSuccess) {
        $scope.completeInProgress = true;

        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/completeorder' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'POST',
                url: url,
                data: {
                    paymentoption: $scope.paymentoption,
                    paymentKey: $scope.paymentKey,
                    issuer: $scope.issuer,
                    employeeNumber: $scope.employeeNumber,
                    changeLocalStockToWarehouseStock: ($scope.OutOfStockValidation.OutOfStock == true && $scope.OutOfStockValidation.ContinueOrder == true),
                    cardholderName: $scope.cardholderName,
                    expirationDate: $scope.expirationDate,
                    last4Digits: $scope.last4Digits,
                    creditcardType: $scope.creditcardType,
                    ga_clientId: $scope.GAclientId()
                },
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                withCredentials: true
            }).then(function (res) {
                if (res.data.Result == true) {
                    //payment successfully.
                    $analytics.createBuilder().asCheckoutStep({
                        step: 3,
                        option: $scope.paymentoption
                    }).send(function () {
                        $scope.OrderConfirmation = res.data;
                        $scope.OutOfStockValidation = res.data.OutOfStockValidation;

                        //Power reviews
                        if (res.data.PowerReviewCredentials != null) {
                            $scope.sendToPowerReviews();
                        }

                        if (callbackSuccess && $scope.paymentoption != 'paypal') {
                            callbackSuccess();
                        }

                        if (res.data.RedirectUrl != null && res.data.RedirectUrl.length > 0) {
                            //redirect to V12 / CF
                            window.location = res.data.RedirectUrl;
                        } else if ($scope.paymentoption == 'affirm') {
                            //redirect to affirm
                            $scope.initiateAffirm();
                        }
                        else if ($scope.paymentoption == 'paypal') {
                            //redirect to paypal
                            $scope.initiatePayPal(res.data.Guid);
                        }
                        else if ($scope.paymentoption == 'paybright') {
                            //redirect to paybright
                            $scope.initiatePayBright(res.data.Guid);
                        } else {
                            //Redirect to confirmationpage
                            window.location = '/' + $window.culture + '/shop/confirmation/' + res.data.Guid + ($window.store != undefined && $window.store.length > 0 ? '/?store=' + $window.store : '/?cartguidvalidation=' + res.data.CartGuidValidation);
                        }
                    });
                } else {
                    //something went wrong
                    $scope.errorPayment = res.data.ExceptionMessage;
                    $scope.completeInProgress = '';
                }
            });
        });
    }

    $scope.sendToPowerReviews = function () {
        try {

            var tracker = POWERREVIEWS.tracker.createTracker({
                merchantGroupId: $scope.OrderConfirmation.PowerReviewCredentials.MerchantGroupID
            });

            var orderFeed = {
                merchantGroupId: $scope.OrderConfirmation.PowerReviewCredentials.MerchantGroupID,
                merchantId: $scope.OrderConfirmation.PowerReviewCredentials.MerchantID,
                locale: window.cultureFull.replace('-', '_'),
                //merchantUserId: 'testuserid',
                marketingOptIn: true,
                userEmail: $scope.Cart.Order.Email,
                userFirstName: $scope.Cart.Order.Firstname,
                userLastName: $scope.Cart.Order.Lastname,
                orderId: $scope.OrderConfirmation.OrderId,
                orderItems: []
            };
            for (var i = 0; i < $scope.Cart.CartItems.length; i++) {
                orderFeed.orderItems.push({
                    page_id: ($scope.Cart.CartItems[i].Product.ProductTypeId == 2 ? 'g-' : 'b-') + $scope.Cart.CartItems[i].Product.Id,
                    product_name: $scope.Cart.CartItems[i].Product.Name,
                    quantity: $scope.Cart.CartItems[i].Quantity,
                    unit_price: $scope.Cart.CartItems[i].Product.PriceOriginal
                });
            }

            tracker.trackCheckout(orderFeed);

        } catch (e) { window.console && window.console.log(e) }
    }

    $scope.initiateSimplefy = function () {
        // Call configure function to redraw the iFrames and to register the callback function.
        CollectJS.configure({
            "timeoutDuration": 5000,
            "timeoutCallback": function () {
                $scope.errorPayment = lblCreditCardTimeout;
                $scope.$apply();
            },
            "callback": function (response) {
                if (response && response.card) {
                    if (response.card.number) {
                        // Get the last 4 digits
                        var startAt = response.card.number.length - 4;
                        $scope.last4Digits = response.card.number.substr(startAt, 4);
                    }

                    if (response.card.exp) {
                        $scope.expirationDate = response.card.exp;
                    }
                }

                $scope.paymentKey = response.token;
                $scope.$apply();
                if (!$scope.IsMobile()) {
                    $scope.completeOrder(function () {
                        $scope.isValidPayment = true;
                        $scope.isValidSummary = false;
                        $scope.proceedPaymentButtonClicked = false;
                    });
                } else {
                    $scope.isValidPayment = true;
                    $scope.isValidSummary = false;
                    $scope.proceedPaymentButtonClicked = false;
                    $scope.$apply();
                    $('#collapseSummary').collapse('show');
                    $('#collapsePayment').collapse('hide');
                }
            },
            "validationCallback": function (field, status, message) {
                console.log(message);

                switch (field) {
                    case 'ccnumber':
                        $scope.simplefyCCNumberValid = status;
                        break;
                    case 'cvv':
                        $scope.simplefyCVVCodeValid = status;
                        break;
                    case 'ccexp':
                        $scope.simplefyExpValid = status;
                        break;
                    default:
                        console.warn('Simplefy field ' + field + ' is unknown');
                }
            }
        });
    }

    $scope.initiateAffirm = function () {
        if ($scope.Cart.AffirmExtraData != null) {
            $window.affirm.checkout({
                "config": {
                    "financial_product_key": "M4MI78P3LSG07I94"
                },

                "financing_program": $scope.Cart.AffirmExtraData.FinancingProgram,

                "merchant": {
                    "user_cancel_url": $scope.Cart.AffirmExtraData.CancelUrl,
                    "user_confirmation_url": $scope.Cart.AffirmExtraData.ConfirmationUrl,
                    "user_confirmation_url_action": "POST",
                },

                "items": $scope.Cart.AffirmExtraData.CartItems,
                "order_id": $scope.OrderConfirmation.OrderId,
                "metadata": {
                    "shipping_type": $scope.OrderConfirmation.ShippingGuid
                },
                "shipping": {
                    "name": {
                        "first": $scope.Cart.Order.Firstname,
                        "last": $scope.Cart.Order.Lastname
                    },
                    "address": {
                        "line1": $scope.Cart.Order.Street,
                        "line2": "",
                        "city": $scope.Cart.Order.City,
                        "state": $scope.Cart.Order.State,
                        "zipcode": $scope.Cart.Order.Postalcode
                    },
                    "phone_number": $scope.Cart.Order.Phone,
                    "email": $scope.Cart.Order.Email
                },
                "billing": {
                    "name": {
                        "first": $scope.Cart.Order.Firstname,
                        "last": $scope.Cart.Order.Lastname
                    },
                    "address": {
                        "line1": $scope.Cart.Order.Street,
                        "line2": "",
                        "city": $scope.Cart.Order.City,
                        "state": $scope.Cart.Order.State,
                        "zipcode": $scope.Cart.Order.Postalcode
                    },
                    "phone_number": $scope.Cart.Order.Phone,
                    "email": $scope.Cart.Order.Email,
                },
                "shipping_amount": Math.round($scope.OrderConfirmation.ShippingCosts * 100),
                "tax_amount": Math.round($scope.OrderConfirmation.Tax * 100),
                "total": Math.round($scope.OrderConfirmation.Total * 100),
            });
        } else {
            //oude manier
            $window.affirm.checkout({
                "config": {
                    "financial_product_key": "M4MI78P3LSG07I94"
                },

                "financing_program": $window.affirmExtraData.financingProgram,

                "merchant": {
                    "user_cancel_url": $window.affirmExtraData.cancelUrl,
                    "user_confirmation_url": $window.affirmExtraData.confirmationUrl,
                    "user_confirmation_url_action": "POST",
                },

                "items": $window.affirmExtraData.cartItems,
                "order_id": $scope.OrderConfirmation.OrderId,
                "metadata": {
                    "shipping_type": $scope.OrderConfirmation.ShippingGuid
                },
                "shipping": {
                    "name": {
                        "first": $scope.firstname,
                        "last": $scope.lastname
                    },
                    "address": {
                        "line1": $scope.street,
                        "line2": "",
                        "city": $scope.city,
                        "state": $scope.state,
                        "zipcode": $scope.postalcode
                    },
                    "phone_number": $scope.phone,
                    "email": $scope.email
                },
                "billing": {
                    "name": {
                        "first": $scope.firstname,
                        "last": $scope.lastname
                    },
                    "address": {
                        "line1": $scope.street,
                        "line2": "",
                        "city": $scope.city,
                        "state": $scope.state,
                        "zipcode": $scope.postalcode
                    },
                    "phone_number": $scope.phone,
                    "email": $scope.email,
                },
                "shipping_amount": Math.round($scope.OrderConfirmation.ShippingCosts * 100),
                "tax_amount": Math.round($scope.OrderConfirmation.Tax * 100),
                "total": Math.round($scope.OrderConfirmation.Total * 100),
            });
        }
        $window.affirm.checkout.post();
    }

    $scope.initiatePayPal = function (guid) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/paypalinitiate/' + guid + '?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $('body').append(res.data);
                $('form#paypal').submit();
            });
        });
    }

    $scope.initiateKlarna = function (guid) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/klarna-initiate?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                try {
                    Klarna.Payments.init({
                        client_token: res.data.Key
                    });
                    Klarna.Payments.load({
                        container: '#klarna-payments-container',
                        payment_method_category: 'pay_later'
                    }, function (res) {
                        console.debug(res);
                    });
                } catch (e) {
                    // Handle error.
                }
            });
        });
    }

    $scope.initiatePayBright = function (guid) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/paybrightinitiate/' + guid + '?r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '');
            $http({
                method: 'GET',
                url: url,
                cache: false,
                withCredentials: true
            }).then(function (res) {
                $('body').append(res.data);
                $('form#paybright').submit();
            });
        });
    }



    //TODO: Implement Enhanced E-Commerce Tracking for Coupon Codes
    $scope.proceedCoupon = function () {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/validatecoupon' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'POST',
                url: url,
                data: { coupon: $scope.coupon.Code },
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                withCredentials: true
            }).then(function (res) {
                $scope.updateCart(function () {
                    $scope.coupon = res.data;
                    if ($scope.coupon.STS != null) {
                        $scope.paymentoption = 'sts';
                    }
                    //get dealers again when coupon is related to dealers
                    if ($scope.coupon.DealerCodes != null && $scope.coupon.DealerCodes.length > 0) {
                        $scope.getGeolocationAndGetDealers();
                    }
                }, 'ValidateCoupon');
            });
        });
    }

    $scope.removeCoupon = function () {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/removecoupon' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'POST',
                url: url,
                withCredentials: true
            }).then(function (res) {
                $scope.updateCart(function () {
                    //get dealers again when coupon is related to dealers
                    if ($scope.coupon.DealerCodes != null && $scope.coupon.DealerCodes.length > 0) {
                        $scope.getGeolocationAndGetDealers();
                    }

                    $scope.coupon = null;
                }, 'RemoveCoupon');
            });
        });
    }

    $scope.unlockCart = function () {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/unlock-cart' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            $http({
                method: 'POST',
                url: url,
                withCredentials: true
            });
        });
    }

    $scope.initPartnumbers = function (id, productTypeId, useGlobalCatalogue) {
        $http({
            method: 'GET',
            url: '/' + $window.culture + '/shop/productselector/' + id + '/' + productTypeId + '/' + useGlobalCatalogue.toLowerCase()
        }).then(function (res) {
            $scope.partnumbers = res.data.Partnumbers;
            $scope.product = res.data.Product;
            //$scope.commerzFinanzLabel = res.data.CommerzFinanzLabel;
            $scope.consorsFinanzLabel = res.data.ConsorsFinanzLabel;
            $scope.colors = res.data.Colors;
            $scope.priceDifferences = res.data.PriceDifferences;
            $scope.hasVariations = res.data.HasVariations;
            $scope.useLocalStockGear = res.data.UseLocalStockGear;

            //remove gallery images
            if ($scope.product.CloudinaryImagesToPartnumbers != null) {
                var tempImages = [];
                for (var i = 0; i < $scope.product.CloudinaryImagesToPartnumbers.length; i++) {
                    if ($scope.product.CloudinaryImagesToPartnumbers[i].CloudinaryImage.IsGalleryImage == false) {
                        tempImages.push($scope.product.CloudinaryImagesToPartnumbers[i]);
                    }
                }
                $scope.product.CloudinaryImagesToPartnumbers = tempImages;
            }

            if ($scope.colors.length > 0) {
                if ($scope.product.CloudinaryImagesToPartnumbers != null && $scope.product.CloudinaryImagesToPartnumbers[0].Color != null) {
                    $scope.color = $scope.product.CloudinaryImagesToPartnumbers[0].Color;
                } else {
                    $scope.color = $scope.colors[0];
                }
            } else {
                $scope.color = "one-color"
            }

            //set default size + color when partnumbercode is located in querystring. Necessary for google feed.
            if (getParameterByName('partnumber') != null && getParameterByName('partnumber').length > 0) {
                $scope.partnumberCode = getParameterByName('partnumber');
                $scope.selectPartnumber();
                $scope.color = $scope.partnumber.color;
                $scope.selectColor2();
                $scope.partnumberCode = getParameterByName('partnumber');
                $scope.selectPartnumber();
            } else if ($scope.product.CloudinaryImagesToPartnumbers != null) {
                $scope.selectColor2($scope.product.CloudinaryImagesToPartnumbers[0]);
            } else {
                $scope.selectColor2();
            }
        });
    }

    $scope.initImages = function (id, productTypeId, useGlobalCatalogue) {
        $http({
            method: 'GET',
            url: '/' + $window.culture + '/shop/productselector/' + id + '/' + productTypeId + '/' + useGlobalCatalogue.toLowerCase()
        }).then(function (res) {
            $scope.product = res.data.Product;

            if ($scope.product.CloudinaryImagesToPartnumbers != undefined && $scope.product.CloudinaryImagesToPartnumbers.length > 0) {
                //remove gallery images
                var tempImages = [];
                for (var i = 0; i < $scope.product.CloudinaryImagesToPartnumbers.length; i++) {
                    if ($scope.product.CloudinaryImagesToPartnumbers[i].CloudinaryImage.IsGalleryImage == false) {
                        tempImages.push($scope.product.CloudinaryImagesToPartnumbers[i]);
                    }
                }
                $scope.product.CloudinaryImagesToPartnumbers = tempImages;

                var cloudinaryImage = $scope.product.CloudinaryImagesToPartnumbers[0];

                $scope.activeImageMain = cloudinaryImage.CloudinaryImage.ImageUrlMain;
                $scope.activeImageLarge = cloudinaryImage.CloudinaryImage.ImageUrlLarge;
                $scope.activeImageSmall = cloudinaryImage.CloudinaryImage.ImageUrlSmall;
                $scope.activeImageThumb = cloudinaryImage.CloudinaryImage.ImageUrlThumb;
                $scope.activeImageZoom = cloudinaryImage.CloudinaryImage.ImageUrlMegaZoom;
                $scope.activeImageIndex = $scope.product.CloudinaryImagesToPartnumbers.indexOf(cloudinaryImage);
            }
        });
    }

    $scope.partnumbersByColor = function () {
        var temp = [];
        for (i = 0; i < $scope.partnumbers.length; i++) {
            if ($scope.color == "one-color" || $scope.partnumbers[i].color == $scope.color) {
                temp.push($scope.partnumbers[i]);
            }
        }
        if ($scope.hasVariations && $scope.partnumber.code != null) {
            var cloudinaryImage = $scope.cloudinaryImageByPartnumberCode($scope.partnumber.code);
            $scope.activeImageMain = cloudinaryImage.CloudinaryImage.ImageUrlMain;
            $scope.activeImageLarge = cloudinaryImage.CloudinaryImage.ImageUrlLarge;
            $scope.activeImageSmall = cloudinaryImage.CloudinaryImage.ImageUrlSmall;
            $scope.activeImageThumb = cloudinaryImage.CloudinaryImage.ImageUrlThumb;
            $scope.activeImageZoom = cloudinaryImage.CloudinaryImage.ImageUrlMegaZoom;
            $scope.activeImageIndex = $scope.product.CloudinaryImagesToPartnumbers.indexOf(cloudinaryImage);
        }
        return temp;
    }

    $scope.cloudinaryImageByPartnumberCode = function (partnumberCode) {
        for (i = 0; i < $scope.product.CloudinaryImagesToPartnumbers.length; i++) {
            for (var j = 0; j < $scope.product.CloudinaryImagesToPartnumbers[i].PartnumberCodes.length; j++) {
                if ($scope.product.CloudinaryImagesToPartnumbers[i].PartnumberCodes[j] == partnumberCode) {
                    return $scope.product.CloudinaryImagesToPartnumbers[i];
                }
            }
        }
    }

    $scope.selectColor2 = function (cloudinaryImage) {
        $scope.partnumber = '';
        $scope.partnumberCode = '';
        $scope.localdealers = [];
        $scope.localdealersCountFiltered = 0;
        if ($scope.color != undefined && $scope.color.length > 0 && $scope.product.CloudinaryImagesToPartnumbers != undefined && $scope.product.CloudinaryImagesToPartnumbers.length > 0) {
            if (cloudinaryImage == null) {
                cloudinaryImage = $scope.cloudinaryImageByPartnumberCode($scope.partnumbersByColor()[0].code);
            }
            // Check if cloudinaryImage object is found. If not, then probably the partnumbercodes are not linked yet to the cloudinary images. Show first image found in this case.
            if (!cloudinaryImage) {
                cloudinaryImage = $scope.product.CloudinaryImagesToPartnumbers[0];
            }

            $scope.activeImageMain = cloudinaryImage.CloudinaryImage.ImageUrlMain;
            $scope.activeImageLarge = cloudinaryImage.CloudinaryImage.ImageUrlLarge;
            $scope.activeImageSmall = cloudinaryImage.CloudinaryImage.ImageUrlSmall;
            $scope.activeImageThumb = cloudinaryImage.CloudinaryImage.ImageUrlThumb;
            $scope.activeImageZoom = cloudinaryImage.CloudinaryImage.ImageUrlMegaZoom;
            $scope.activeImageIndex = $scope.product.CloudinaryImagesToPartnumbers.indexOf(cloudinaryImage);
        }

        if ($scope.partnumbersByColor().length == 1) {
            $scope.partnumberCode = $scope.partnumbersByColor()[0].code;
            $scope.partnumber = $scope.partnumbersByColor()[0];
            $scope.selectPartnumber();
        } else if (cloudinaryImage != null && $scope.hasVariations && $scope.colors.length == 1) {
            //speciaal voor producten als wheelsystems
            for (var i = 0; i < cloudinaryImage.PartnumberCodes.length; i++) {
                for (var j = 0; j < $scope.partnumbers.length; j++) {
                    if ($scope.partnumbers[j].code == cloudinaryImage.PartnumberCodes[i]) {
                        $scope.partnumberCode = cloudinaryImage.PartnumberCodes[i];
                        $scope.selectPartnumber();
                        break;
                    }
                }
            }
        }

        setTimeout(function () {
            angular.element('.selectpicker').selectpicker('refresh');
            //angular.element('#partnumberSelect .selectpicker').selectpicker('refresh');
        });
    }

    $scope.selectPartnumber = function () {
        for (i = 0; i < $scope.partnumbers.length; i++) {
            if ($scope.partnumbers[i].code == $scope.partnumberCode) {
                $scope.partnumber = $scope.partnumbers[i];
                break;
            }
        }
        if ($scope.product.ProductType == 1 || $scope.useLocalStockGear) {
            if ($scope.partnumber != null) {
                $scope.getLocalDealers();
                $scope.getDealers(null, null, true);
            } else {
                $scope.localdealers = [];
                $scope.localdealersCountFiltered = 0;
            }
        }
        setTimeout(function () {
            $scope.supplementaryItemPartnumberCode = '';
            angular.element('#supplementaryItemSelect .selectpicker').selectpicker('refresh');
        });
    }

    $scope.addCartItem = function (dealerCode) {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/addcartitem' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
            var data = {
                productId: $scope.product.Id,
                partnumberCode: $scope.partnumber.code,
                productType: $scope.product.ProductType,
                quantity: 1,
                globalCatalogue: $scope.product.IsGlobalCatalogue,
                GAclientId: $scope.GAclientId(),
                supplementaryItemPartnumberCode: $scope.supplementaryItemPartnumberCode
            };
            if (dealerCode != null) {
                data["dealerCode"] = dealerCode;
            }

            $http({
                method: 'POST',
                url: url,
                cache: false,
                withCredentials: true,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                data: data
                //data: { productId: $scope.product.Id, partnumberCode: $scope.partnumber.code, productType: $scope.product.ProductType, quantity: 1, dealerCode: (dealerCode != null ? dealerCode : null), globalCatalogue: $scope.product.IsGlobalCatalogue, GAclientId: $scope.GAclientId(), supplementaryItemPartnumberCode: $scope.supplementaryItemPartnumberCode },
            }).then(function (res) {
                angular.element('#ModalLocalStockFinder').modal('hide');
                if (res.data.result > 0) {
                    $rootScope.$broadcast('cartUpdated');
                    angular.element('#cartModal').modal('show');

                    AnalyticsBuilder.create(window.inTestMode ? { debug: true } : {}).addProduct({
                        'id': $scope.partnumber.code,
                        'name': $scope.product.Name,
                        'quantity': 1
                    }).asAddToCart().send({
                        label: dealerCode != null && dealerCode.length > 0 ? 'Pick it up here' : 'Add to cart'
                    });
                } else {
                    angular.element('#cartModalError').modal('show');
                }
            });
        });
    }

    $scope.changeColorDropdown = function (cloudinaryImageToPartnumbers) {
        if (cloudinaryImageToPartnumbers.Color != null && cloudinaryImageToPartnumbers.Color.length > 0) {
            //image related to partnumber
            $scope.color = cloudinaryImageToPartnumbers.Color;
            $scope.selectColor2(cloudinaryImageToPartnumbers);

            setTimeout(function () {
                angular.element('#colorSelect .selectpicker').selectpicker('refresh');
            });
        } else {
            //image NOT related to partnumber
            if ($scope.colors.length > 1) {
                //nodig indien een foto is aangeklikt die niet gerelateerd is aan een kleur.
                $scope.color = '';
            }
            $scope.activeImageMain = cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlMain;
            $scope.activeImageLarge = cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlLarge;
            $scope.activeImageSmall = cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlSmall;
            $scope.activeImageThumb = cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlThumb;
            $scope.activeImageZoom = cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlZoom;
            $scope.activeImageIndex = $scope.product.CloudinaryImagesToPartnumbers.indexOf(cloudinaryImageToPartnumbers);
            $scope.selectColor2(cloudinaryImageToPartnumbers);
        }
    };

    $scope.changeZoomedImageModal = function (cloudinaryImageToPartnumbers) {
        $scope.activeImageZoom = cloudinaryImageToPartnumbers.CloudinaryImage.ImageUrlMegaZoom;
    };


    $scope.compare = function (e) {
        var data = {
            globalcatalogue: e.$parent.product.IsGlobalCatalogue == true ? "True" : "False",
            id: e.$parent.product.Id,
            image: e.$parent.activeImageSmall,
            name: e.$parent.product.Name
        };

        window.compareStore.add(data);
    }

    $scope.sendStockAlert = function () {
        $scope.errorStockAlert = '';
        if ($scope.formStockAlert.$valid) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/shop/stockalert' + ($window.store != undefined && $window.store.length > 0 ? '?store=' + $window.store : '');
                $http({
                    method: 'POST',
                    url: url,
                    cache: false,
                    withCredentials: true,
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    data: { partnumberCode: $scope.partnumber.code, email: $scope.notificationEmail, zipcode: $scope.notificationZipcode },
                }).then(function (res) {
                    if (res.data == "True") {
                        angular.element('#stockAlertModal').modal('hide');
                    } else {
                        $scope.errorStockAlert = res.data;
                    }
                });
            });
        } else {
            if ($scope.formStockAlert.$error.required != undefined && $scope.formStockAlert.$error.required.length > 0) {
                $scope.errorStockAlert += lblMakeSureAllRequiredFieldsAreEntered;
            }
            if ($scope.formStockAlert.$error.email != undefined && $scope.formStockAlert.$error.email.length > 0) {
                $scope.errorStockAlert += lblWrongEmailHasBeenEntered;
            }
        }
    }

    $scope.sendContactForm = function () {
        $scope.errorContact = '';
        if ($scope.formContact.$valid) {
            var url = '/' + $window.culture + '/contact/sendjson';
            $http({
                method: 'POST',
                url: url,
                cache: false,
                withCredentials: true,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: function (obj) {
                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                data: { Name: $scope.contactName, email: $scope.contactEmail, question: $scope.contactQuestion, ProductId: $scope.contactProductId, ProductType: $scope.contactProductType, isGlobalCatalogue: $scope.contactIsGlobalCatalogue },
            }).then(function (res) {
                if (res.data == "True") {
                    angular.element('#contactModal').modal('hide');
                } else {
                    $scope.errorContact = res.data;
                }
            });
        } else {
            if ($scope.formContact.$error.required != undefined && $scope.formContact.$error.required.length > 0) {
                $scope.errorContact += lblMakeSureAllRequiredFieldsAreEntered;
            }
            if ($scope.formContact.$error.email != undefined && $scope.formContact.$error.email.length > 0) {
                $scope.errorContact += lblWrongEmailHasBeenEntered;
            }
        }
    }

    $scope.IsMobile = function () {
        return helpers.isMobile();
    }

    $scope.isIOS = function () {
        if (window.ApplePaySession) {
            //alert("canMakePaymentsWithActiveCard");
            var merchantIdentifier = 'merchant.giant-bicycles.com';
            var promise = ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
            //alert(promise);
            promise.then(function (canMakePayments) {
                //alert(canMakePayments);
                if (canMakePayments) {
                    $scope.IOS = true;
                    //HTMLCollection.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
                    //var buttons = document.getElementsByClassName("apple-pay-button");
                    //for (let button of buttons) {
                    //    button.className += " visible";
                    //}
                }
            });
        } else {
            //alert('NO');
            //return false;
        }
    }

    $scope.getPaymentOption = function (code) {
        if ($scope.Cart.PaymentOptions != null) {
            for (var i = 0; i < $scope.Cart.PaymentOptions.length; i++) {
                if ($scope.Cart.PaymentOptions[i].code == code) {
                    return $scope.Cart.PaymentOptions[i];
                }
            }
        }
    }

    $scope.resetContactInfo = function () {
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/shop/resetcontactinfo';
            $http({
                method: 'POST',
                url: url,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                withCredentials: true
            }).then(function (res) {
                location.reload();
            });
        });
    }

    $scope.selectPartnumberByBarcode = function (barcode) {
        for (i = 0; i < $scope.partnumbers.length; i++) {
            if ($scope.partnumbers[i].barcode == barcode) {
                $scope.partnumberCode = $scope.partnumbers[i].code
                $scope.partnumber = $scope.partnumbers[i];
                $scope.selectPartnumber();
                setTimeout(function () {
                    angular.element('#sizes.selectpicker').selectpicker('refresh');
                });
                break;
            }
        }

    }

    $scope.validateAddress = function () {
        if (countryId == 16 && $scope.Cart.Order.Street != null && $scope.Cart.Order.Street.length > 0) {
            $scope.containsValidAddress = /\d/.test($scope.Cart.Order.Street);
        }
    }

    $scope.runAwardClick = function (awardUrl) {
        if (awardUrl != undefined && awardUrl.length > 0) {
            // track click
            trackEventGlobalAndLocal('Award', 'Click', awardUrl);
            // go to url
            $window.open(awardUrl, '_blank');
        }

    }


}]);

app.controller('Stores', ['$scope', 'helpers', function ($scope, helpers) {
    $scope.dealercity = $('#keyword').val();
    $scope.country = country;
    $scope.latlng = defaultLatitude + ',' + defaultLongitude;

    $scope.keydown = function () {
        if (event.keyCode == 13) {
            $scope.getGeolocation();
        }
    }

    $scope.getBrowserlocation = function () {
        helpers.getBrowserLocation(function (lat, lng, dealercity) {
            $scope.latlng = lat + ',' + lng;
            $scope.dealercity = dealercity;
            $scope.$apply();
            $('#latlng').val($scope.latlng);
            $('#keyword').val($scope.dealercity);
            $('form#Geocoder').submit();
        });
    }

    $scope.getGeolocation = function () {
        helpers.getGeolocation($scope.dealercity, function (lat, lng) {
            $scope.latlng = lat + ',' + lng;
            $scope.$apply();
            $('#latlng').val($scope.latlng);
            console.log('Search: ' + $scope.dealercity + ' ' + $scope.country + ', Result: ' + $scope.latlng);
            $('form#Geocoder').submit();
        });
    };
}]);

app.controller('Stores2', ['$scope', 'helpers', 'uiGmapGoogleMapApi', '$http', 'uiGmapIsReady', function ($scope, helpers, uiGmapGoogleMapApi, $http, uiGmapIsReady) {
    $scope.keyword = '';
    $scope.KeywordLatitude = 0;
    $scope.KeywordLongitude = 0;
    $scope.keywordErrorMessage = false;
    $scope.country = country;
    $scope.latlng = defaultLatitude + ',' + defaultLongitude;
    $scope.dealers = [];
    $scope.markers = [];
    $scope.showStartpage = true;
    $scope.campaigns = [];
    $scope.selectedCampaigns = [];
    $scope.showFilterbox = false;
    $scope.markerscontrol = {};
    $scope.infoWindow = '';
    $scope.showGiantStoresDefaultAtStoreFinder = false;
    $scope.rectangle = null;

    $scope.setMarkers = function () {
        $scope.markers = [];

        if (window.inTestMode != undefined && window.inTestMode) {
            $scope.markers.push({
                latitude: $scope.KeywordLatitude,
                longitude: $scope.KeywordLongitude,
                id: 0,
                show: false,
            });
        }

        $.each($scope.dealers, function (i, dealer) {
            $scope.markers.push({
                latitude: dealer.Latitude,
                longitude: dealer.Longitude,
                title: dealer.Name,
                id: dealer.Id,
                icon: cdn + '/Images/Shared/Stores/' + dealer.MarkerFileName,
                show: false,
                dealer: dealer,
                events: {
                    click: function (e, f, g) {
                        $scope.map.selectedMarker = g;
                        if ($scope.infoWindow) {
                            $scope.infoWindow.close();
                        }
                        $scope.infoWindow = new google.maps.InfoWindow({
                            content: g.infoWindow()
                        });
                        $scope.infoWindow.open(e.map, e)
                    }
                },
                infoWindow: function () {

                    var isInTestMode = (window.inTestMode != undefined && window.inTestMode ? true : false);

                    return (dealer.Image != null ? '<div class="image" style="margin-bottom:10px;"><img src="' + dealer.Image + '" class="img-responsive" style="width:280px;"/></div>' : '') + '<strong>' + dealer.Name + '</strong><br />' +
                        dealer.AddressLocalized + '<br/>' +
                        (dealer.Phone != null ? dealer.Phone + '<br />' : '') +
                        (dealer.Email != null ? '<a href="mailto:' + dealer.Email + '" class="dealer-email">' + dealer.Email + '</a><br />' : '') +
                        (dealer.WebAddress != null && isInTestMode && countryId == 19 && dealer.IsGiantStore ? "" : dealer.WebAddress ? '<a href="http://' + dealer.WebAddress + '" target="_blank" class="dealer-webaddress">' + dealer.WebAddress + '</a><br>' : '') +
                        (dealer.Facebook != null ? '<a href="' + dealer.Facebook + '" target="_blank" class="dealer-webaddress">' + dealer.Facebook + '</a><br>' : '') +
                        (isInTestMode && countryId == 19 && dealer.IsGiantStore ? '<br/><a href="/' + culture + '/store/' + dealer.StoreShortname + '">View store details <span class="glyphicon glyphicon-circle-arrow-right"></span></a>' : ($scope.giantstorespage == true) ? '<a href="http://' + dealer.WebAddress + '" class="btn btn-info">Bekijk store pagina</a>' : '<div style="margin-top:10px;"><a href="https://www.google.com/maps?saddr=' + $scope.KeywordLatitude + ',' + $scope.KeywordLongitude + '&daddr=' + dealer.Latitude + ',' + dealer.Longitude + '" target="_blank"><span class="glyphicon glyphicon-circle-arrow-right"></span> ' + labelDirections + '</a></div>');
                }
            });
        });
    };

    $scope.map = {
        center: {
            latitude: defaultLatitude,
            longitude: defaultLongitude
        },
        bounds: {
            northeast: {
                latitude: 0,
                longitude: 0
            },
            southwest: {
                latitude: 0,
                longitude: 0
            }
        },
        zoom: defaultZoom,
        control: {},
        events: {
            zoom_changed: function (map, eventName, arguments) {
                $scope.mapChanged(map);
            },
            dragend: function (map, eventName, arguments) {
                $scope.mapChanged(map);
            }
        },
        options: {
            scrollwheel: false
        },
        selectedMarker: {}
    };

    $scope.mapChanged = function (map) {
        if ($scope.keyword.length > 0) {
            var padbnds = $scope.addPaddingToBounds(map, 35, 0, 12, 12); //north, south, east and west
            $scope.map.bounds = {
                northeast: {
                    latitude: padbnds.getNorthEast().lat(),
                    longitude: padbnds.getNorthEast().lng()
                },
                southwest: {
                    latitude: padbnds.getSouthWest().lat(),
                    longitude: padbnds.getSouthWest().lng()
                }
            };
            console.log('NE: ' + $scope.map.bounds.northeast.latitude + ',' + $scope.map.bounds.northeast.longitude);
            console.log('SW: ' + $scope.map.bounds.southwest.latitude + ',' + $scope.map.bounds.southwest.longitude);

            //if (window.inTestMode != undefined && window.inTestMode) {
            //    if ($scope.rectangle != null) {
            //        $scope.rectangle.setMap(null);
            //    }

            //    $scope.rectangle = new google.maps.Rectangle({
            //        strokeColor: '#FF0000',
            //        strokeOpacity: 0.3,
            //        strokeWeight: 1,
            //        fillColor: '#FF0000',
            //        fillOpacity: 0.16,
            //        map: map,
            //        bounds: {
            //            north: padbnds.getNorthEast().lat(),
            //            south: padbnds.getSouthWest().lat(),
            //            east: padbnds.getNorthEast().lng(),
            //            west: padbnds.getSouthWest().lng()
            //        }
            //    });
            //}

            $scope.getDealers();
        }
    };

    $scope.showInfoWindow = function (id) {
        $scope.map.selectedMarker = $scope.markers.filter(function (x) { return x.id == id })[0];
        var marker = $scope.markerscontrol.getGMarkers().filter(function (x) { return x.key == id })[0];
        $scope.map.selectedMarker.events.click(marker, 'click', $scope.map.selectedMarker);
    };

    $scope.keydown = function () {
        if (event.keyCode == 13 && $scope.keyword.length > 0) {
            $scope.getGeolocation();
        }
    }

    $scope.getBrowserlocation = function () {
        $scope.showGiantStoresDefaultAtStoreFinder = false;
        helpers.getBrowserLocation(function (lat, lng, keyword) {
            $scope.map.center.latitude = lat;
            $scope.map.center.longitude = lng;
            $scope.keyword = keyword;
            $scope.KeywordLatitude = lat;
            $scope.KeywordLongitude = lng;
            $scope.showStartpage = false;
            //$scope.map.options.scrollwheel = true;
            $scope.resetBounds();
            $scope.getDealers($scope.fitBounds);
            $scope.keywordErrorMessage = false;
        });
    }

    $scope.getGeolocation = function () {
        if ($scope.keyword.length > 0) {
            $scope.showGiantStoresDefaultAtStoreFinder = false;
        } else {
            $scope.showGiantStoresDefaultAtStoreFinder = true;
        }

        console.log();

        helpers.getGeolocation($scope.keyword, function (lat, lng) {
            if (lat != undefined && lng != undefined) {
                $scope.map.center.latitude = lat;
                $scope.map.center.longitude = lng;
                $scope.KeywordLatitude = lat;
                $scope.KeywordLongitude = lng;
                $scope.showStartpage = false;
                if ($scope.giantstorespage == true) {
                    $scope.map.options.scrollwheel = false;
                } else {
                    $scope.map.options.scrollwheel = true;
                }
                $scope.resetBounds();
                $scope.getDealers($scope.fitBounds);
                $scope.keywordErrorMessage = false;
            } else {
                $scope.keywordErrorMessage = true;
                $scope.$apply();
            }
        });
    };

    $scope.initiateDealerSearch = function () {
        for (var i = 0; i < $scope.campaigns.length; i++) {
            if ($scope.campaigns[i].selected == true) {
                $scope.setCampaign($scope.campaigns[i].code);

                var the_string = 'selectCampaign' + $scope.campaigns[i].code;
                $scope[the_string] = '' + $scope.campaigns[i].code + '';
            }
        }
    }

    $scope.getDealers = function (callback) {
        $http({
            method: 'POST',
            url: '/' + culture + '/stores/dealers',
            data: {
                latitude: $scope.KeywordLatitude,
                longitude: $scope.KeywordLongitude,
                keyword: $scope.keyword,
                NE_lat: $scope.map.bounds.northeast.latitude,
                NE_lng: $scope.map.bounds.northeast.longitude,
                SW_lat: $scope.map.bounds.southwest.latitude,
                SW_lng: $scope.map.bounds.southwest.longitude,
                campaigncodes: $scope.selectedCampaigns,
                onlyGiantStores: $scope.giantstorespage ? true : false
            }
        }).then(function (res) {
            if (res.data.dealers != undefined && res.data.dealers.length > 0) {
                $scope.dealers = res.data.dealers;
                $scope.filteredBy = res.data.filteredBy;
                $scope.setMarkers();
            }
            if (callback) {
                callback();
            }
        });
    }

    $scope.fitBounds = function () {
        $scope.map.control.refresh();
        if ($scope.dealers.length > 0) {
            var bounds = new google.maps.LatLngBounds();
            $.each($scope.dealers, function (i, dealer) {
                bounds.extend(new google.maps.LatLng(dealer.Latitude, dealer.Longitude));
            });
            //append keyword coordinates to have always 'your home' located.
            bounds.extend(new google.maps.LatLng($scope.KeywordLatitude, $scope.KeywordLongitude));
            var map = $scope.map.control.getGMap();
            map.fitBounds(bounds);
        }
    }

    $scope.resetBounds = function () {
        $scope.map.bounds = {
            northeast: {
                latitude: 0,
                longitude: 0
            },
            southwest: {
                latitude: 0,
                longitude: 0
            }
        };
    }

    $scope.toggleFilterbox = function () {
        if ($scope.showFilterbox) {
            $scope.showFilterbox = false;
        } else {
            $scope.showFilterbox = true;
        }
    }

    $scope.setCampaign = function (code) {
        if ($scope.selectedCampaigns.indexOf(code) > -1) {
            $scope.selectedCampaigns.splice($scope.selectedCampaigns.indexOf(code), 1);
        } else {
            $scope.selectedCampaigns.push(code);
        }
    }

    $scope.selectCampaign = function (code) {
        //if ($scope.selectedCampaigns.indexOf(code) > -1) {
        //    $scope.selectedCampaigns.splice($scope.selectedCampaigns.indexOf(code), 1);
        //} else {
        //    $scope.selectedCampaigns.push(code);
        //}
        $scope.setCampaign(code);

        if ($scope.selectedCampaigns.length == 0) {
            $scope.resetBounds();
        }
        $scope.getDealers($scope.fitBounds);
        $scope.toggleFilterbox();
    }

    $scope.dealerCampaigns = function (campaignCodes) {
        var result = [];
        $.each(campaignCodes, function (i, campaignCode) {
            if (result.filter(function (x) { return x == campaignCode }).length == 0 && $scope.campaigns.filter(function (x) { return x.code == campaignCode }).length > 0) {
                result.push($scope.campaigns.filter(function (x) { return x.code == campaignCode })[0]);
            }
        });
        return result;
    }

    $scope.addPaddingToBounds = function (map, npad, spad, epad, wpad) {
        var SW = map.getBounds().getSouthWest();
        var NE = map.getBounds().getNorthEast();
        var topRight = map.getProjection().fromLatLngToPoint(NE);
        var bottomLeft = map.getProjection().fromLatLngToPoint(SW);
        var scale = Math.pow(2, map.getZoom());

        var SWtopoint = map.getProjection().fromLatLngToPoint(SW);
        var SWpoint = new google.maps.Point(((SWtopoint.x - bottomLeft.x) * scale) + wpad, ((SWtopoint.y - topRight.y) * scale) - spad);
        var SWworld = new google.maps.Point(SWpoint.x / scale + bottomLeft.x, SWpoint.y / scale + topRight.y);
        var pt1 = map.getProjection().fromPointToLatLng(SWworld);

        var NEtopoint = map.getProjection().fromLatLngToPoint(NE);
        var NEpoint = new google.maps.Point(((NEtopoint.x - bottomLeft.x) * scale) - epad, ((NEtopoint.y - topRight.y) * scale) + npad);
        var NEworld = new google.maps.Point(NEpoint.x / scale + bottomLeft.x, NEpoint.y / scale + topRight.y);
        var pt2 = map.getProjection().fromPointToLatLng(NEworld);

        return new google.maps.LatLngBounds(pt1, pt2);
    }
}]);

app.controller('Registration', ['$scope', 'helpers', '$http', '$window', '$q', 'accountService', '$sce', 'cartService', function ($scope, helpers, $http, $window, $q, accountService, $sce, cartService) {
    $scope.Registration = [];
    $scope.base64Object = [];
    $scope.fileResizeLoading = false;
    $scope.showPersonalData = false;
    $scope.containsValidAddress = true;

    $scope.Login = function () {
        accountService.Login($scope.loginEmail, $scope.loginPassword, true).then(function () {
            if (accountService._account.result != null && accountService._account.result.Token != null && accountService._account.result.Token.length > 0) {
                $scope.Registration.Registration.Gender = accountService._account.result.Details.GenderToFormat;
                $scope.Registration.Registration.FirstName = accountService._account.result.Details.OrderFirstname;
                $scope.Registration.Registration.LastName = accountService._account.result.Details.OrderLastname;
                $scope.Registration.Registration.Address = accountService._account.result.Details.OrderStreet;
                $scope.Registration.Registration.PostalCode = accountService._account.result.Details.OrderPostalcode;
                $scope.Registration.Registration.City = accountService._account.result.Details.OrderCity;
                $scope.Registration.Registration.State = accountService._account.result.Details.OrderState;
                $scope.Registration.Registration.Phone = accountService._account.result.Details.OrderPhone;
                $scope.Registration.Registration.Email = accountService._account.result.Details.OrderEmail;
                $scope.Registration.Registration.BirthDateToFormat = accountService._account.result.Details.BirthDateToFormat;
                $scope.Registration.Registration.AxaptaConsumerAccountNumber = accountService._account.result.Details.OrderAxaptaConsumerAccountNumber;
                $scope.Registration.Registration.AddToNewsletter = accountService._account.result.Details.OrderAddToNewsletter;
                $scope.showPersonalData = true;
                $scope.Registration.UserAlreadyExists = false;
                $scope.validateAddress();
            } else {
                $scope.errorLogin = accountService._account.error;
            }
        });
    }

    $scope.Logout = function () {
        accountService.Logout();
    }

    $scope.uploadReceipt = function () {
        $('#filestyle-0').trigger('click');
        $scope.fileResizeLoading = true;
    }

    $scope.resizeImage = function (file, base64_object) {
        //https://github.com/adonespitogo/angular-base64-upload
        //https://github.com/oliver-moran/jimp
        // file is an instance of File constructor.
        // base64_object is an object that contains compiled base64 image data from file.
        $scope.fileResizeLoading = true;
        $scope.$apply();
        var deferred = $q.defer();
        var url = URL.createObjectURL(file);// creates url for file object.
        Jimp.read(url)
            .then(function (item) {
                item
                    .resize(800, Jimp.AUTO)// width of 1280px, auto-adjusted height
                    .quality(50)//drops the image quality to 50%
                    .getBase64(file.type, function (err, newBase64) {
                        if (err) { throw err; }
                        var bytes = Math.round((3 / 4) * newBase64.length);
                        $scope.base64Object.filetype = file.type;
                        $scope.base64Object.filesize = bytes;
                        $scope.base64Object.filename = file.name;
                        $scope.base64Object.base64 = newBase64;
                        $scope.base64Object.base64Replaced = newBase64.replace('data:image/jpeg;base64,', '');
                        // Note that base64 in this package doesn't contain "data:image/jpeg;base64," part,
                        // while base64 string from Jimp does. It should be taken care of in back-end side.
                        $scope.fileResizeLoading = false;
                        $scope.$apply();
                        deferred.resolve($scope.base64Object);
                    });
            })
            .catch(function (err) {
                return console.log(err);// error handling
            });
        return deferred.promise;
    };

    $scope.reset = function () {
        var serial = $scope.Registration.Registration.SerialNumber;
        $scope.Registration = [];
        $scope.Registration.Registration = [];
        $scope.Registration.Registration.SerialNumber = serial;
        $scope.isValidSelectBike = false;
        $scope.isValidContactInfo = false;
        $scope.isValidPointOfPurchase = false;
    }

    $scope.collapseIsAuthorizedToEdit = function (collapseName) {
        //Check of this collapse block can be opened when previous collapse blocks are valid
        switch (collapseName) {
            case 'selectbike':
                return true;
            case 'contactinfo':
                return $scope.collapseIsValid('selectbike');
            case 'pointofpurchase':
                return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('selectbike');
            case 'purchasedate':
                return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('selectbike') && $scope.collapseIsValid('pointofpurchase');
            case 'confirmation':
                return $scope.collapseIsValid('contactinfo') && $scope.collapseIsValid('selectbike') && $scope.collapseIsValid('pointofpurchase') && $scope.collapseIsValid('purchasedate');
            default:
                return false;
        }
    }

    $scope.collapseIsValid = function (collapseName) {
        //Check of all required fields have been set
        switch (collapseName) {
            case 'selectbike':
                return $scope.isValidSelectBike;
            case 'contactinfo':
                return $scope.isValidContactInfo;
            case 'pointofpurchase':
                return $scope.isValidPointOfPurchase;
            case 'purchasedate':
                return $scope.isValidPurchaseDate;
            case 'confirmation':
                return $scope.isValidConfirmation;
            default:
                return false;
        }
    }

    //Step 1
    $scope.proceedSelectBike = function (selectLocknumber) {
        //check required fields
        $scope.errorSelectBike = '';
        $scope.file = [];
        $scope.proceedSelectBikeButtonClicked = true;
        if ($scope.formSelectBike.$valid) {
            grecaptcha.ready(function () {
                grecaptcha.execute(window.GoogleRecaptchaSiteKey, { action: 'social' })
                    .then(function (token) {
                        cartService.MasterDomain().then(function () {
                            var url = cartService._masterDomain + '/' + $window.culture + '/registration/findBike';
                            $http({
                                method: 'POST',
                                url: url,
                                data: { serialNumber: $scope.Registration.Registration.SerialNumber, lockNumber: $scope.Registration.Registration.LockNumber != undefined ? $scope.Registration.Registration.LockNumber : null, token: token, guid: $scope.Registration.Registration.Guid },
                                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                transformRequest: function (obj) {
                                    //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                                    var str = [];
                                    for (var p in obj)
                                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                                    return str.join("&");
                                },
                                withCredentials: true
                            }).then(function (res) {
                                if (res.data.Result == true) {
                                    $scope.Registration = res.data;
                                    $scope.isValidSelectBike = true;
                                    if (res.data.Registration.HasLockNumber == false || (selectLocknumber != undefined && selectLocknumber == true)) {
                                        $('#collapseContactInfo').collapse('show');
                                        $('#collapseSelectBike').collapse('hide');
                                    }
                                    if ($scope.Registration.Registration.AxaptaConsumerAccountNumber != null && $scope.Registration.Registration.AxaptaConsumerAccountNumber.length > 0) {
                                        $scope.showPersonalData = true;
                                    }
                                } else {
                                    $scope.errorSelectBike = res.data.ErrorMessage;
                                    $scope.Registration = [];
                                }
                                $scope.proceedSelectBikeButtonClicked = false;
                            });
                        });
                    });
            });
        } else {
            if ($scope.formSelectBike.$error.required != undefined && $scope.formSelectBike.$error.required.length > 0) {
                $scope.errorSelectBike += lblMakeSureAllRequiredFieldsAreEntered;
            }
        }
    }

    //Step 2
    $scope.proceedContactInfo = function () {
        //check required fields
        $scope.errorContactInfo = '';
        $scope.btnSubmitContactInfo = true;
        if ($scope.formContactInfo.$valid) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/registration/saveContact?source=contactInfo&createUser=true';
                $http({
                    method: 'POST',
                    url: url,
                    data: $('#formContactInfo').serialize(),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    withCredentials: true
                }).then(function (res) {
                    if (res.data.Result == true) {
                        $scope.Registration = res.data;
                        $scope.isValidContactInfo = true;
                        $('#collapseContactInfo').collapse('hide');
                        if ($scope.Registration.Registration.ReceivedDealerFromAxapta == false) {
                            $scope.dealercity = $scope.Registration.Registration.Address + ' ' + $scope.Registration.Registration.PostalCode + ' ' + $scope.Registration.Registration.City;
                            $scope.getGeolocationAndGetDealers(function () { $('#collapsePointOfPurchase').collapse('show'); });
                        } else {
                            $('#collapsePointOfPurchase').collapse('show');
                        }
                    } else {
                        if (res.data.UserAlreadyExists == true) {
                            $scope.Registration.UserAlreadyExists = true;
                        } else {
                            $scope.errorContactInfo = res.data.ErrorMessage;
                        }
                    }
                    $scope.btnSubmitContactInfo = false;
                });
            });
        } else {
            if ($scope.formContactInfo.$error.required != undefined && $scope.formContactInfo.$error.required.length > 0) {
                $scope.errorContactInfo += lblMakeSureAllRequiredFieldsAreEntered;
            }
        }
    }

    //Step 3a
    $scope.proceedPointOfPurchase = function () {
        //check required fields
        $scope.errorPointOfPurchase = '';
        $scope.btnSubmitPointOfPurchase = true;
        if ($scope.formPointOfPurchase.$valid) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/registration/saveContact?source=pointOfPurchase';
                $http({
                    method: 'POST',
                    url: url,
                    data: $('#formContactInfo').serialize(),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    withCredentials: true
                }).then(function (res) {
                    if (res.data.Result == true) {
                        $scope.Registration = res.data;
                        $scope.isValidPointOfPurchase = true;
                        $('#collapsePointOfPurchase').collapse('hide');
                        $('#collapsePurchaseDate').collapse('show');
                    } else {
                        $scope.errorPointOfPurchase = res.data.ErrorMessage;
                    }
                    $scope.btnSubmitPointOfPurchase = false;
                });
            });
        } else {
            if ($scope.formPointOfPurchase.$error.required != undefined && $scope.formPointOfPurchase.$error.required.length > 0) {
                $scope.errorPointOfPurchase += lblMakeSureAllRequiredFieldsAreEntered;
            }
        }
    }

    //Step 3b
    $scope.proceedSelectDealer = function (dealer) {
        $('#hiddenDealerCode').val(dealer.Code);
        $scope.errorPointOfPurchase = '';
        $scope.btnSubmitPointOfPurchase = true;
        cartService.MasterDomain().then(function () {
            var url = cartService._masterDomain + '/' + $window.culture + '/registration/saveContact?source=selectDealer';
            $http({
                method: 'POST',
                url: url,
                data: $('#formContactInfo').serialize(),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
            }).then(function (res) {
                if (res.data.Result == true) {
                    $scope.Registration = res.data;
                    $scope.isValidPointOfPurchase = true;
                    $('#collapsePointOfPurchase').collapse('hide');
                    $('#collapsePurchaseDate').collapse('show');
                } else {
                    $scope.errorPointOfPurchase = res.data.ErrorMessage;
                }
                $scope.btnSubmitPointOfPurchase = false;
            });
        });
    }

    //Step 4
    $scope.proceedPurchaseDate = function () {
        //check required fields
        $scope.errorPurchaseDate = '';
        $scope.btnSubmitPurchaseDate = true;
        if ($scope.formPurchaseDate.$valid) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/registration/saveContact?source=purchaseDate';
                $http({
                    method: 'POST',
                    url: url,
                    data: $('#formContactInfo').serialize(),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    withCredentials: true
                }).then(function (res) {
                    if (res.data.Result == true) {
                        $scope.Registration = res.data;
                        $scope.isValidPurchaseDate = true;
                        $('#collapsePurchaseDate').collapse('hide');
                        $('#collapseConfirmation').collapse('show');
                    } else {
                        $scope.errorPurchaseDate = res.data.ErrorMessage;
                    }
                    $scope.btnSubmitPurchaseDate = false;
                });
            });
        } else {
            if ($scope.formPurchaseDate.$error.required != undefined && $scope.formPurchaseDate.$error.required.length > 0) {
                $scope.errorPurchaseDate += lblMakeSureAllRequiredFieldsAreEntered;
            }
        }
    }

    //Step 5
    $scope.proceedConfirmation = function () {
        //check required fields
        $scope.errorConfirmation = '';
        $scope.btnSubmitConfirmation = true;
        if ($scope.formConfirmation.$valid) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/registration/saveContact?source=confirmation&confirm=true';
                $http({
                    method: 'POST',
                    url: url,
                    data: $('#formContactInfo').serialize(),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    withCredentials: true
                }).then(function (res) {
                    if (res.data.Result == true) {
                        $scope.Registration = res.data;
                        $scope.isValidConfirmation = true;
                        $('#collapseConfirmation').collapse('hide');
                    } else {
                        $scope.errorConfirmation = res.data.ErrorMessage;
                    }
                    $scope.btnSubmitConfirmation = false;
                });
            });
        } else {
            if ($scope.formConfirmation.$error.required != undefined && $scope.formConfirmation.$error.required.length > 0) {
                $scope.errorConfirmation += lblMakeSureAllRequiredFieldsAreEntered;
            }
        }
    }

    $scope.showWilmarModal = function () {
        $('#wilmarModal').modal('show');
    }

    $scope.initWilmar = function () {
        $scope.errorInitWilmar = '';
        $scope.proceedInitWilmarButtonClicked = true;
        if ($scope.wilmarEmail.length > 0 && getParameterByName('p') != null && getParameterByName('p').length > 0) {
            cartService.MasterDomain().then(function () {
                var url = cartService._masterDomain + '/' + $window.culture + '/registration/initWilmar';
                $http({
                    method: 'POST',
                    url: url,
                    data: { p: getParameterByName('p'), email: $scope.wilmarEmail },
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    transformRequest: function (obj) {
                        //Deze transformatie is nodig icm Content-Type anders krijg je een 404 preflight error (http://stackoverflow.com/questions/24710503/how-do-i-post-urlencoded-form-data-with-http-in-angularjs)
                        var str = [];
                        for (var p in obj)
                            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                        return str.join("&");
                    },
                    withCredentials: true
                }).then(function (res) {
                    if (res.data.Result == true) {
                        $scope.Registration = res.data;
                        $scope.isValidSelectBike = true;
                        $scope.isValidContactInfo = true;
                        $scope.isValidPointOfPurchase = true;
                        if ($scope.Registration.Registration.BuyDateToFormat.length > 0) {
                            $scope.isValidPurchaseDate = true;
                        }
                        $('#collapseSelectBike').collapse('hide');
                        $('#collapseContactInfo').collapse('show');
                        $('#wilmarModal').modal('hide');
                        $scope.errorInitWilmar = '';
                    } else {
                        $scope.errorInitWilmar = res.data.ErrorMessage;
                    }
                    $scope.proceedInitWilmarButtonClicked = false;
                });
            });
        }
    }

    $scope.getBrowserlocationAndGetDealers = function () {
        helpers.getBrowserLocation(function (lat, lng, dealercity) {
            $scope.latitude = lat;
            $scope.longitude = lng;
            $scope.dealercity = dealercity;
            $scope.getDealers();
        });
    }

    $scope.getGeolocationAndGetDealers = function (callback) {
        helpers.getGeolocation($scope.dealercity, function (lat, lng) {
            $scope.latitude = lat;
            $scope.longitude = lng;
            $scope.getDealers();
            if (callback) {
                callback();
            }
        });
    }

    $scope.getDealers = function () {
        $http({
            method: 'POST',
            url: '/' + culture + '/stores/dealers',
            data: {
                latitude: $scope.latitude,
                longitude: $scope.longitude,
                keyword: $scope.dealercity
            }
        }).then(function (res) {
            $scope.dealers = res.data.dealers;
        });
    }

    $scope.parseHtml = function (html) {
        return $sce.trustAsHtml(html);
    };

    $scope.validateAddress = function () {
        if (countryId == 16 && $scope.Registration.Registration.Address.length > 0) {
            $scope.containsValidAddress = /\d/.test($scope.Registration.Registration.Address);
        }
    }

}]);

angular.bootstrap(document, ['app']);